import gql from "graphql-tag";

export default class Queries {
  static LoggedInUserQuery = gql`
    query LoggedInUserQuery {
      loggedInUser {
        id
        email        
      }
    }
  `;

  static AuthenticateUserMutation = gql`
    mutation AuthenticateUserMutation($email: String!, $password: String!) {
      authenticateUser(email: $email, password: $password) {
        token
        user {
          id
        }
      }
    }
  `;

  static ChangePasswordMutation = gql`
    mutation ChangePasswordMutation(
      $currentPassword: String!
      $newPassword: String!
    ) {
      changePassword(
        currentPassword: $currentPassword
        newPassword: $newPassword
      ) {
        token
        user {
          id
        }
      }
    }
  `;

  static resetPasswordMutation = gql`
    mutation resetPasswordMutation($token: String!, $newPassword: String!) {
      resetPassword(token: $token, newPassword: $newPassword) {
        token
        user {
          id
        }
      }
    }
  `;

  static loggedInUserQueryForCompanies = gql`
    query loggedInUserQueryForCompanies {
      loggedInUser {
        id
        firstname
        name
        email   
      }
    }
  `;

  static userProfile = gql`
    query userProfile {
      loggedInUser {
        id
        firstname
        name
        email
        telFixe
        telMobile
      }
    }
  `;

  static myCompaniesMeta = gql`
    query myCompaniesMeta($where: CompanyWhereInput) {
      myCompaniesMeta(where2: $where) {
        count
      }
    }
  `;


static endOfLifeData = gql`
    query endOfLifeData(
      $userId: ID!
    ) {
      endOfLifeData (
        userId: $userId
      ){
        isEndOfLife
        endOfLifeMessageBannerFR
        endOfLifeMessageTitleFR
        endOfLifeMessage01FR
        endOfLifeMessage02FR
        endOfLifeMessage03FR
        endOfLifeMessage04FR
        endOfLifeMessage05FR
        endOfLifeMessageButtonFR
        endOfLifeMessageBannerEN
        endOfLifeMessageTitleEN
        endOfLifeMessage01EN
        endOfLifeMessage02EN
        endOfLifeMessage03EN
        endOfLifeMessage04EN
        endOfLifeMessage05EN
        endOfLifeMessageButtonEN
      }
    }
  `;

  static myCompanies = gql`
    query myCompanies(
      $userId: ID!
      $skip: Int!
      $first: Int!
      $where: CompanyWhereInput
    ) {
      myCompanies(
        orderBy: name_ASC
        skip: $skip
        first: $first
        where2: $where
      ) {
        id
        name
        currency {
          id
        }
        active
        userCompanies(where: { user: { id: $userId } }) {
          id
          role
          tiers {
            id
            client {id}
            supplier {id}
            collaborator {id}
          } 
          user {
            id
            email
          }         
        }
        invitations (where: {email: "COMPANY TYPE OPTIONS"}) {
          id
          name
        }
      }
    }
  `;

  static CompaniesQuery = gql`
    query CompaniesQuery(
      $userId: ID!
      $where: CompanyWhereInput!
      $skip: Int!
      $first: Int!
    ) {
      companies(skip: $skip, first: $first, orderBy: name_ASC, where: $where) {
        id
        name
        currency {
          id
        }
        userCompanies(where: { user: { id: $userId } }) {
          id
          tiers {
            id
          }          
          role
          active
        }
      }
    }
  `;

  // basic get company infos used at company creation time
  static companyQueryForSidebar = gql`
    query companyQueryForSidebar($companyId: ID) {
      company(where: { id: $companyId }) {
        id
        name
        currency {
          id
        }
      }
    }
  `;

  static SIGNUP_USER_MUTATION = gql`
    mutation SignupUserMutation(
      $email: String!
      $password: String!
      $name: String!
      $firstname: String!
    ) {
      signupUser(
        email: $email
        password: $password
        name: $name
        firstname: $firstname
      ) {
        token
        user {
          id
        }
      }
    }
  `;

  static currencyByIdForCurrencyInput = gql`
    query currencyByIdForCurrencyInput($currencyId: ID!) {
      currency(where: { id: $currencyId }) {
        id
        symbol
        code
        decimalSeparator
        thousandSeparator
      }
    }
  `;

  static GetCurrencyByCode = gql`
    query GetCurrencyByCode($code: String!) {
      currency(where: { code: $code }) {
        id
        symbol
      }
    }
  `;

  static GetCountries = gql`
    query GetCountries {
      countries {
        id
        label
      }
    }
  `;

  static GetCountryByLabel = gql`
    query GetCountry($label: String!) {
      country(where: { label: $label }) {
        id
        label
      }
    }
  `;

  static CreateCompany = gql`
    mutation CreateCompany(
      $name: String!
      $dateCreation: DateTime
      $address: String
      $currencyId: ID!
      $zipCode: String
      $city: String
      $countryId: ID
      $isTaxActive: Boolean
      $defaultClientAccountLabel: String
      $defaultSupplierAccountLabel: String
      $defaultCollaboratorAccountLabel: String
      $defaultTermNetsFinDeMois: TermNetsFinDeMoisEnum
      $defaultTermDelaisPaiement: TermDelaisDePaiementEnum
      $planComptableCharCount: Int
      $formeJuridique: String
      $siren: String
      $siret: String
      $codeAPE: String
      $numeroTVA: String
      $capitalSocial: String
      $userId: ID
      $role: RoleEnum
    ) {
      # $taxValue: Float # # $taxName: String
      createCompany(
        data: {
          name: $name
          dateCreation: $dateCreation
          currency: { connect: { id: $currencyId } }
          isTaxActive: $isTaxActive
          defaultClientAccountLabel: $defaultClientAccountLabel
          defaultSupplierAccountLabel: $defaultSupplierAccountLabel
          defaultCollaboratorAccountLabel: $defaultCollaboratorAccountLabel
          defaultTermNetsFinDeMois: $defaultTermNetsFinDeMois
          defaultTermDelaisPaiement: $defaultTermDelaisPaiement
          planComptableCharCount: $planComptableCharCount
          formeJuridique: $formeJuridique
          siren: $siren
          siret: $siret
          codeAPE: $codeAPE
          numeroTVA: $numeroTVA
          capitalSocial: $capitalSocial
          addresses: {
            create: {
              label: "Principal"
              address: $address
              zipCode: $zipCode
              city: $city
              country: { connect: { id: $countryId } }
            }
          }
          userCompanies: {
            create: { role: $role, user: { connect: { id: $userId } } }
          }
        }
      ) {
        id
        isTaxActive
      }
    }
  `;

  // static createCompanyTax = gql`
  //   mutation createTax($label: String, $valuePourcent: Float, $companyId: ID) {
  //     createTax(
  //       data: {
  //         label: $label
  //         valuePourcent: $valuePourcent
  //         company:{ connect: {  id: $companyId }}
  //         companyTax1 :{ connect: { id: $companyId }}
  //       }
  //     ) {
  //       id
  //       label
  //       valuePourcent
  //       company {
  //         id
  //       }
  //       companyTax1 {
  //         id
  //       }
  //     }
  //   }
  // `;

  static createCompanyTax = gql`
    mutation updateCompany(
      $label: String
      $valuePourcent: Float
      $companyId: ID
      $active: Boolean
      $mode: TaxModeEnum
      $xtraData: String
    ) {
      updateCompany(
        where: { id: $companyId }
        data: {
          taxes: {
            create: [
              {
                label: $label
                valuePourcent: $valuePourcent
                active: $active
                mode: $mode
                xtraData: $xtraData
              }
            ]
          }
        }
      ) {
        id
        taxes {
          id
          label
          valuePourcent
          active
          mode
          xtraData
        }
      }
    }
  `;

  static updateCompanyTax = gql`
    mutation updateCompanyTax(
      $label: String
      $valuePourcent: Float
      $companyId: ID!
      $taxId: ID!
      $active: Boolean
      $mode: TaxModeEnum
      $xtraData: String
    ) {
      updateTax(
        where: { id: $taxId }
        companyId: $companyId
        data: {
          label: $label
          valuePourcent: $valuePourcent
          active: $active
          mode: $mode
          xtraData: $xtraData
        }
      ) {
        id
        label
        valuePourcent
        active
        mode
        xtraData
      }

      # updateCompany(
      #   where: { id: $companyId }
      #   data: {
      #     taxes: {
      #       update: [
      #         {
      #           where: { id: $taxId }
      #           data: {
      #             label: $label
      #             valuePourcent: $valuePourcent
      #             active: $active
      #             mode: $mode
      #           }
      #         }
      #       ]
      #     }
      #   }
      # ) {
      #   id
      #   taxes {
      #     id
      #     label
      #     valuePourcent
      #     active
      #     mode
      #   }
      # }
    }
  `;

  static userForUserProfile = gql`
    query user($userId: ID!) {
      user(id: $userId) {
        id
        firstname
        name
        email
        userCompanies {
          id
          secondaryemail
          role
        }
        avatarPictureUrl
        telMobile
        telFixe
        newsletterActive
      }
    }
  `;

  static updateUserForUserProfile = gql`
    mutation updateUser(
      $userId: ID!
      $active: Boolean
      $connectedAgenda: Boolean
      $connectedContacts: Boolean
      $defaultLinesCount: Int
      $email: String
      $firstname: String
      $name: String
      $newsletterActive: Boolean
      $telFixe: String
      $telMobile: String
    ) {
      updateUser(
        where: { id: $userId }
        data: {
          active: $active
          connectedAgenda: $connectedAgenda
          connectedContacts: $connectedContacts
          defaultLinesCount: $defaultLinesCount
          email: $email
          firstname: $firstname
          name: $name
          newsletterActive: $newsletterActive
          telFixe: $telFixe
          telMobile: $telMobile
        }
      ) {
        # userCompanies: { #   id: $companyId #   secondaryemail: $secondaryemail # }
        id
        # active
        # connectedAgenda
        # connectedContacts
        # defaultLinesCount
        email
        firstname
        name
        newsletterActive
        telFixe
        telMobile
      }
    }
  `;

  static userForEndOfLife = gql`
    query user($userId: ID!) {
      user(id: $userId) {
        id
        telFixe
        endOfLifeAccepted
        endOfLifeAcceptedDate
      }
    }
  `;

  static updateUserForEndOfLife = gql`
    mutation updateUser(
      $userId: ID!
      $endOfLifeAccepted: Boolean
      $endOfLifeAcceptedDate: DateTime
    ) {
      updateUser(
        where: { id: $userId }
        data: {
          endOfLifeAccepted: $endOfLifeAccepted
          endOfLifeAcceptedDate: $endOfLifeAcceptedDate
        }
      ) {   
        id
      }
    }
  `;

  static updateUserCompany = gql`
    mutation updateUserCompany($userCompanyId: ID!, $secondaryemail: String) {
      updateUserCompany(
        where: { id: $userCompanyId }
        data: { secondaryemail: $secondaryemail }
      ) {
        id
        secondaryemail
      }
    }
  `;

  static userCompanyList = gql`
    query userCompanyList($userId: ID!, $companyId: ID) {
      userCompanies(
        where: { user: { id: $userId }, company: { id: $companyId } }
      ) {
        id
        role
      }
    }
  `;

  static createExpense = gql`
    mutation CreateExpense(
      $tiersId: ID!
      $date: DateTime
      $totalTTC: Float
      $companyCurrencyTotalTTC: Float
      $totalHT: Float
      $totalTax: Float
      $currencyId: ID!
      $expiryDate: DateTime
      $description: String
      $companyId: ID!
      $creatorId: ID!
      $status: ExpenseStatus
      $numeroPiece: String
      $taxPieces: TaxPieceCreateManyWithoutExpenseInput
      $withoutProof: Boolean
    ) {
      createExpense(
        data: {
          tiers: { connect: { id: $tiersId } }
          date: $date
          totalTTC: $totalTTC
          companyCurrencyTotalTTC: $companyCurrencyTotalTTC
          totalHT: $totalHT
          totalTax: $totalTax
          currency: { connect: { id: $currencyId } }
          dateEcheance: $expiryDate
          description: $description
          company: { connect: { id: $companyId } }
          creator: { connect: { id: $creatorId } }
          status: $status
          taxPieces: $taxPieces
          numeroPiece: $numeroPiece
          withoutProof: $withoutProof          
        }
      ) {
        id
        tiers {
          id
        }
        date
        totalTTC
        companyCurrencyTotalTTC
        totalHT
        totalTax
        currency {
          id
        }
        dateEcheance
        description
        creator {
          id
        }
        status
        numeroPiece
      }
    }
  `;

  static createExpenseLine = gql`
    mutation CreateExpenseLine(
      $expenseId: ID!
      $categoryId: ID
      $valueHT: Float
      $numLine: Int
    ) {
      createExpenseLine(
        data: {
          expense: { connect: { id: $expenseId } }
          category: { connect: { id: $categoryId } }
          numLine: $numLine
          valueHT: $valueHT
        }
      ) {
        id
      }
    }
  `;

  static connectExpenseLine = gql`
    mutation connectExpenseLine(
      $id: ID!
      $withClient: Boolean!
      $withProject: Boolean!
      $disconnectProject: Boolean! = false
      $disconnectTiersClient: Boolean! = false
      $tiersClientId: ID
      $projectId: ID
    ) {
      client: updateExpenseLine(
        where: { id: $id }
        data: { tiersClient: { connect: { id: $tiersClientId } } }
      ) @include(if: $withClient) {
        id
        tiersClient {
          id
        }
      }
      project: updateExpenseLine(
        where: { id: $id }
        data: { project: { connect: { id: $projectId } } }
      ) @include(if: $withProject) {
        id
        project {
          id
        }
      }
      disconnectProject: updateExpenseLine(
        where: { id: $id }
        data: { project: { disconnect: $disconnectProject } }
      ) @include(if: $disconnectProject) {
        id
        project {
          id
        }
      }
      disconnectTiersClient: updateExpenseLine(
        where: { id: $id }
        data: { tiersClient: { disconnect: $disconnectTiersClient } }
      ) @include(if: $disconnectTiersClient) {
        id
        project {
          id
        }
      }
    }
  `;

  static updateExpense = gql`
    mutation UpdateExpense(
      $id: ID!
      $status: ExpenseStatus
      $tiersId: ID
      $date: DateTime
      $totalTTC: Float
      $companyCurrencyTotalTTC: Float
      $totalHT: Float
      $totalTax: Float
      $currencyId: ID
      $expiryDate: DateTime
      $description: String
      $numeroPiece: String
      $creatorId: ID
      $taxPiecesToCreate: [TaxPieceCreateWithoutExpenseInput!]
      # $taxPiecesToUpdate: [TaxPieceUpdateWithWhereUniqueWithoutExpenseInput!]
      $taxPiecesToDelete: [TaxPieceWhereUniqueInput!]
      $createTaxPieces: Boolean!
      # $updateTaxPieces: Boolean!
      $deleteTaxPieces: Boolean!
      $withoutProof: Boolean
    ) {
      taxPiecesDeleted: updateExpense(
        where: { id: $id }
        data: { taxPieces: { delete: $taxPiecesToDelete } }
      ) @include(if: $deleteTaxPieces) {
        id
        taxPieces {
          id
        }
      }
      taxPiecesCreated: updateExpense(
        where: { id: $id }
        data: { taxPieces: { create: $taxPiecesToCreate } }
      ) @include(if: $createTaxPieces) {
        id
        taxPieces {
          id
        }
      }
      # taxPiecesUpdated: updateExpense(
      #   where: { id: $id }
      #   data: { taxPieces: { update: $taxPiecesToUpdate } }
      # ) @include(if: $updateTaxPieces) {
      #   id
      #   taxPieces {
      #     id
      #   }
      # }
      updateExpense(
        where: { id: $id }
        data: {
          status: $status
          tiers: { connect: { id: $tiersId } }
          date: $date
          totalTTC: $totalTTC
          companyCurrencyTotalTTC: $companyCurrencyTotalTTC
          totalHT: $totalHT
          totalTax: $totalTax
          currency: { connect: { id: $currencyId } }
          dateEcheance: $expiryDate
          description: $description
          numeroPiece: $numeroPiece
          withoutProof: $withoutProof
          creator: { connect: { id: $creatorId } }
        }
      ) {
        id
        numeroPiece
        totalTTC
        companyCurrencyTotalTTC
        totalHT
        totalTax
        status
        description
        dateEcheance
        creator {
          id
        }
        date
        tiers {
          name
          id
        }
        attachment {
          id
        }
        currency {
          id
        }
        taxPieces {
          id
        }
        expenseLines {
          id
          valueHT
          valueTax
          tiersClient {
            id
            name
          }
          category {
            id
            ids
            name
          }
          project {
            id
            name
          }
        }
      }
    }
  `;

  static updateExpenseStatus = gql`
    mutation UpdateExpense($id: ID!, $status: ExpenseStatus) {
      updateExpense(where: { id: $id }, data: { status: $status }) {
        id
        status
      }
    }
  `;

  static deleteExpense = gql`
    mutation DeleteExpense($id: ID!) {
      updateExpense(where: { id: $id }, data: { isDeleted: true }) {
        id
        status
        dateEcheance
      }
    }
  `;

  static payExpenses = gql`
    mutation PayExpenses(
      $expenseIds: [ID]!
      $bankTransactionEcritureLineIds: [ID]
      $bankAccountId: ID!
      $datePay: DateTime
      $paymentLibelle: String
    ) {
      payExpenses(
        where: {
          expenseIds: $expenseIds
          bankTransactionEcritureLineIds: $bankTransactionEcritureLineIds
          bankAccountId: $bankAccountId
          datePay: $datePay
        }
        data: { paymentLibelle: $paymentLibelle }
      ) {
        id
      }
    }
  `;

  static createExpensesEcritures = gql`
    mutation createExpensesEcritures(
      $expenseIds: [ID]!
      $bankTransactionEcritureLineIds: [ID]
      $bankTransactionId: ID
    ) {
      createExpensesEcritures(
        where: {
          expenseIds: $expenseIds
          bankTransactionEcritureLineIds: $bankTransactionEcritureLineIds
          bankTransactionId: $bankTransactionId
        }
      ) {
        result
      }
    }
  `;

  static restoreExpense = gql`
    mutation RestoreExpense($id: ID!) {
      updateExpense(where: { id: $id }, data: { isDeleted: false }) {
        id
        status
        dateEcheance
      }
    }
  `;

  static getCompanyName = gql`
    query getCompanyName($companyId: ID!) {
      company(where: { id: $companyId }) {
        id
        name
      }
    }
  `;

  static getLatestExpenseByTiers = gql`
    query getLatestExpenseByTiers($companyId: ID!, $tiersId: ID!) {
      getLatestExpenseByTiers(companyId: $companyId, tiersId: $tiersId) {
        id
        date
        tiers {
          id
        }
        taxPieces {
          id
          label
          taux
          tax {
            id
            valuePourcent
          }
        }
        expenseLines {
          id
          numLine
          project {
            id
          }
          tiersClient {
            id
          }
          category {
            id
            ids
            name
          }
        }
      }
    }
  `;

  static getLatestExpenseByTiersAndAmount = gql`
    query getLatestExpenseByTiersAndAmount(
      $companyId: ID!
      $tiersId: ID!
      $amount: Float
      # $amountMin: Float
      # $amountMax: Float
    ) {
      getLatestExpenseByTiersAndAmount(
        companyId: $companyId
        tiersId: $tiersId
        amount: $amount
        # amountMin: $amountMin
        # amountMax: $amountMax
      ) {
        id
        date
        totalTTC
        tiers {
          id
        }
        taxPieces {
          id
          label
          taux
          amount
          tax {
            id
            valuePourcent
          }
        }
        expenseLines {
          id
          valueHT
          numLine
          project {
            id
          }
          tiersClient {
            id
          }
          category {
            id
            ids
            name
          }
        }
      }
    }
  `;

  // static getLatestTiersExpense = gql`
  //   query latestExpense($companyId: ID, $tiersId: ID) {
  //     myCompanies(where2: { id: $companyId }) {
  //       id
  //       expenses(
  //         where: {
  //           AND: [
  //             { isDeleted: false }
  //             { tiers: { id: $tiersId } }
  //             { status_not: AVALIDER }
  //             { expenseLines_some: { category: { id_not: null } } }
  //           ]
  //         }
  //         first: 1
  //         orderBy: date_DESC
  //       ) {
  //         id
  //         date
  //         tiers {
  //           id
  //         }
  //         taxPieces {
  //           id
  //           label
  //           tax {
  //             id
  //             valuePourcent
  //           }
  //         }
  //         expenseLines {
  //           id
  //           numLine
  //           project {
  //             id
  //           }
  //           category {
  //             id
  //             ids
  //             name
  //           }
  //         }
  //       }
  //     }
  //   }
  // `;

  static getCompanyInfoForContainer = gql`
    query getCompanyInfoForContainer($companyId: ID) {
      company: company(where: { id: $companyId }) {
        id
        name
        codeExportVente
        codeExportAchat
        codeExportEcart
        country {
          id
          label
        }
        isTaxActive
        tax1 {
          id
          label
          valuePourcent
          active
        }
        tax2 {
          id
          label
          valuePourcent
          active
        }
        currency {
          id
          code
        }
        addresses {
          id
          address
          country {
            id
            label
          }
        }
        footer
        logoes {
          id
          path
        }
        documents {
          id
          language {
            id
          }
          conditionsDeVente
          pdfCgvLabel
          pdfCgvPath
          pdfCgvKey
          pdfCgvBucket
          subjectQuotation
          bodyQuotation
          subjectInvoice
          bodyInvoice
          subjectRelance
          bodyRelance
        }
        versionPDF
        firmColor
        relanceAvantPaiement
        relanceApresPaiement
      }
      language: language(where: { code: "FR" }) {
        id
        code
      }
      languageEN: language(where: { code: "EN" }) {
        id
        code
      }
    }
  `;

  static expenseCount = gql`
    query expensesCount(
      $allFilter: ExpenseWhereInput
      $draftFilter: ExpenseWhereInput
      $dueFilter: ExpenseWhereInput
      $lateFilter: ExpenseWhereInput
      $removedFilter: ExpenseWhereInput
    ) {
      allCount: _allExpensesMeta(where: $allFilter) {
        count
      }

      draftCount: _allExpensesMeta(where: $draftFilter) {
        count
      }

      dueCount: _allExpensesMeta(where: $dueFilter) {
        count
      }

      lateCount: _allExpensesMeta(where: $lateFilter) {
        count
      }

      removedCount: _allExpensesMeta(where: $removedFilter) {
        count
      }
    }
  `;

  // Articles counts for ArticleTabs in ArticleList
  static articleCount = gql`
    query articlesCount($companyId: ID!) {
      allCount: _articlesMeta(where: { company: { id: $companyId } }) {
        count
      }

      activeCount: _articlesMeta(
        where: { company: { id: $companyId }, active: true }
      ) {
        count
      }

      inactiveCount: _articlesMeta(
        where: { company: { id: $companyId }, active: false }
      ) {
        count
      }
    }
  `;

  static GET_EXPENSE = gql`
    query GetExpense($id: ID!, $companyId: ID!) {
      expense(where: { id: $id }, companyId: $companyId) {
        id
        isDeleted
        numeroPiece
        totalTTC
        companyCurrencyTotalTTC
        totalHT
        totalTax
        status
        origin
        description
        dateEcheance
        availableActions
        taxPieces {
          id
          label
          amount
          taux
          tax {
            id
          }
        }
        creator {
          id
        }
        date
        tiers {
          name
          id
        }
        attachment {
          id
          path
          bucket
          label
          key
        }
        withoutProof
        currency {
          id
        }
        expenseLines(orderBy: numLine_ASC) {
          id
          valueHT
          numLine
          tiersClient {
            id
            name
          }
          category {
            id
            ids
            name
          }
          project {
            id
            name
          }
        }
        events(orderBy: date_DESC) {
          id
          date
          eventType
          tiers {
            id
            firstname
            lastname
          }
        }
      }
    }
  `;

  static GET_ALL_EXPENSES_BATCHED = gql`
    query GetAllExpenses(
      $companyId: ID!
      $filter: ExpenseWhereInput
      $filterCount: ExpenseWhereInput # $skip: Int! # $first: Int!
    ) {
      _allExpensesMeta(where: $filterCount) {
        count
      }

      batch0: company(where: { id: $companyId }) {
        id
        expenses(first: 1000, skip: 0, where: $filter, orderBy: date_DESC) {
          ...expenseInfo
        }
      }

      batch1: company(where: { id: $companyId }) {
        id
        expenses(
          first: 1000
          skip: 1000
          where: $filter # orderBy: date_DESC
        ) {
          ...expenseInfo
        }
      }
      batch2: company(where: { id: $companyId }) {
        id
        expenses(
          first: 1000
          skip: 2000
          where: $filter # orderBy: date_DESC
        ) {
          ...expenseInfo
        }
      }

      batch3: company(where: { id: $companyId }) {
        id
        expenses(
          first: 1000
          skip: 3000
          where: $filter # orderBy: date_DESC
        ) {
          ...expenseInfo
        }
      }

      batch4: company(where: { id: $companyId }) {
        id
        expenses(
          first: 1000
          skip: 4000
          where: $filter # orderBy: date_DESC
        ) {
          ...expenseInfo
        }
      }

      batch5: company(where: { id: $companyId }) {
        id
        expenses(
          first: 1000
          skip: 5000
          where: $filter # orderBy: date_DESC
        ) {
          ...expenseInfo
        }
      }

      batch6: company(where: { id: $companyId }) {
        id
        expenses(
          first: 1000
          skip: 6000
          where: $filter # orderBy: date_DESC
        ) {
          ...expenseInfo
        }
      }

      batch7: company(where: { id: $companyId }) {
        id
        expenses(
          first: 1000
          skip: 7000
          where: $filter # orderBy: date_DESC
        ) {
          ...expenseInfo
        }
      }

      batch8: company(where: { id: $companyId }) {
        id
        expenses(
          first: 1000
          skip: 8000
          where: $filter # orderBy: date_DESC
        ) {
          ...expenseInfo
        }
      }

      batch9: company(where: { id: $companyId }) {
        id
        expenses(
          first: 1000
          skip: 9000
          where: $filter # orderBy: date_DESC
        ) {
          ...expenseInfo
        }
      }
    }

    fragment expenseInfo on Expense {
      id
      creator {
        id
      }
      date
      tiers {
        name
        id
      }
      companyCurrencyTotalTTC
      totalTTC
      totalTax
      totalHT
      status
      attachment {
        id
        path
        bucket
        label
      }
      currency {
        id
      }
      expenseLines {
        id
        category {
          name
          ids
          id
        }
      }
    }
  `;

  static GET_ALL_EXPENSES_FOR_ExpenseList = gql`
    query GetAllExpenses(
      $companyId: ID!
      $filterCount: ExpenseWhereInput
      $skip: Int
      $first: Int
    ) {
      _allExpensesMeta(where: $filterCount) {
        count
      }

      getAllExpenses(
        companyId: $companyId
        first: $first
        skip: $skip
        filterCount: $filterCount
      ) {
        id
        creator {
          id
        }
        date
        dateEcheance
        numeroPiece
        attachment {
          id
        }
        withoutProof
        tiers {
          id
          name
          supplier {
            id
          }
          collaborator {
            id
          }
        }
        companyCurrencyTotalTTC
        totalTTC
        totalTax
        totalHT
        status
        currency {
          id
        }
        company {
          id
          currency {
            id
          }
        }
        expenseLines(orderBy: numLine_ASC) {
          id
          project {
            id
            name
          }
          tiersClient {
            id
            name
          }
          category {
            id
            ids
            name
          }
        }
      }

      # company(where: { id: $companyId }) {
      #   id
      #   expenses(
      #     first: $first
      #     skip: $skip
      #     where: $filter
      #     orderBy: date_DESC
      #   ) {
      #     id
      #     creator {
      #       id
      #     }
      #     date
      #     dateEcheance
      #     attachment {
      #       id
      #     }

      #     tiers {
      #       id
      #       name
      #     }
      #     totalTTC
      #     totalTax
      #     totalHT
      #     status
      #     currency {
      #       id
      #     }
      #     expenseLines {
      #       id
      #       category {
      #         id
      #         name
      #       }
      #     }
      #   }
      # }
    }
  `;

  static GET_ALL_EXPENSES = gql`
    query GetAllExpenses(
      $companyId: ID!
      $filter: ExpenseWhereInput
      $filterCount: ExpenseWhereInput
      $skip: Int
      $first: Int
    ) {
      _allExpensesMeta(where: $filterCount) {
        count
      }

      company(where: { id: $companyId }) {
        id
        expenses(
          first: $first
          skip: $skip
          where: $filter
          orderBy: date_DESC
        ) {
          id
          creator {
            id
          }
          date
          tiers {
            name
            id
          }
          companyCurrencyTotalTTC
          totalTTC
          totalTax
          totalHT
          status
          numeroPiece
          attachment {
            id
            path
            bucket
            label
          }
          withoutProof
          currency {
            id
          }
          company {
            id
            currency {
              id
            }
          }
          expenseLines {
            id
            category {
              name
              ids
              id
            }
          }
        }
      }
    }
  `;

  static GET_INVOICES_COUNT = gql`
    query invoicesCount(
      # $companyId: ID!
      $lateFilter: InvoiceWhereInput
      $draftFilter: InvoiceWhereInput
    ) {
      # allCount: _allInvoicesMeta(
      #   where: { company: { id: $companyId }, isDeleted: false }
      # ) {
      #   count
      # }

      draftCount: _allInvoicesMeta(where: $draftFilter) {
        count
      }

      #  dueCount: _allInvoicesMeta(
      #    where: { company: { id: $companyId }, isDeleted: false, status: DUE }
      #  ) {
      #    count
      #  }

      lateCount: _allInvoicesMeta(where: $lateFilter) {
        count
      }
      # removedCount: _allInvoicesMeta(
      #   where: { company: { id: $companyId }, isDeleted: true }
      # ) {
      #   count
      # }
    }
  `;

  // static GET_ALL_INVOICES = gql`
  //   query GetAllInvoices(
  //     $companyId: ID!
  //     $filter: InvoiceWhereInput!
  //     $skip: Int!
  //     $first: Int!
  //   ) {
  //     _allInvoicesMeta(
  //       where: { AND: [$filter, { company: { id: $companyId } }] }
  //     ) {
  //       count
  //     }
  //     company(where: { id: $companyId }) {
  //       id
  //       invoices(
  //         first: $first
  //         skip: $skip
  //         where: $filter
  //         orderBy: date_DESC
  //       ) {
  //         id
  //         numeroPiece
  //         creator {
  //           id
  //           name
  //         }
  //         currency {
  //           id
  //         }
  //         tiersClient {
  //           id
  //           name
  //         }
  //         date
  //         dateEcheance
  //         totalTTC
  //         companyCurrencyTotalTTC
  //         totalHTAvantRemise
  //         totalHTApresRemise
  //         titre
  //         numeroPiece
  //         status
  //         tiersClient {
  //           id
  //           name
  //         }
  //       }
  //     }
  //   }
  // `;

  static GET_ALL_INVOICES = gql`
    query GetAllInvoices(
      $companyId: ID!
      $filterCount: InvoiceWhereInput
      #$filter: InvoiceWhereInput!
      $skip: Int!
      $first: Int!
      # $requestOnlyOnePageToggle: Boolean
    ) {
      _allInvoicesMeta(where: $filterCount){ #, requestOnlyOnePageToggle: $requestOnlyOnePageToggle) {
        count
      }

      getAllInvoices(
        companyId: $companyId
        first: $first
        skip: $skip
        filterCount: $filterCount
        # requestOnlyOnePageToggle: $requestOnlyOnePageToggle
      ) {
        id
        numeroPiece
        address
        creator {
          id
          name
        }
        currency {
          id
        }
        company {
          id
          currency {
            id
          }
        }
        tiersClient {
          id
          name
        }
        project {
          id
          name
        }
        date
        dateEcheance
        totalTTC
        companyCurrencyTotalTTC
        totalHTAvantRemise
        totalHTApresRemise
        titre
        numeroPiece
        status
        attachment {
          id
          bucket
          key
          label
          path
        }
        taxPieces {
          id
          amount
        }
        recurrence {
          id
          active
          monthFrequency
          endMonthYear
          generateRealInvoice
          sendInvoice
        }
      }

      # company(where: { id: $companyId }) {
      #   id
      #   invoices(orderBy: date_DESC, where: $filter) {
      #     id
      #     numeroPiece
      #     creator {
      #       id
      #       name
      #     }
      #     currency {
      #       id
      #     }
      #     tiersClient {
      #       id
      #       name
      #     }
      #     project {
      #       id
      #       name
      #     }
      #     date
      #     dateEcheance
      #     totalTTC
      #     companyCurrencyTotalTTC
      #     totalHTAvantRemise
      #     totalHTApresRemise
      #     titre
      #     numeroPiece
      #     status
      #     tiersClient {
      #       id
      #       name
      #     }
      #   }
      # }
    }
  `;

  static GetAllQuotations = gql`
    query GetAllQuotations(
      $companyId: ID!
      $filterCount: QuotationWhereInput
      $skip: Int!
      $first: Int!
    ) {
      quotationCount(where: $filterCount) {
        count
      }

      getAllQuotations(
        companyId: $companyId
        first: $first
        skip: $skip
        filterCount: $filterCount
      ) {
        id
        numeroPiece
        address
        creator {
          id
          name
        }
        currency {
          id
        }
        company {
          id
          currency {
            id
          }
        }
        tiersClient {
          id
          name
        }
        project {
          id
          name
        }
        date
        dateValidation
        dateValidite
        # companyCurrencyTotalTTC
        totalTTC
        totalHTAvantRemise
        totalHTApresRemise
        titre
        numeroPiece
        status
        tiersClient {
          id
          name
        }
        attachment {
          id
          bucket
          key
          label
          path
        }
      }

      # company(where: { id: $companyId }) {
      #   id
      #   quotations(orderBy: date_DESC, where: $filter) {
      #     id
      #     numeroPiece
      #     creator {
      #       id
      #       name
      #     }
      #     currency {
      #       id
      #     }
      #     tiersClient {
      #       id
      #       name
      #     }
      #     date
      #     dateValidation
      #     totalTTC
      #     # companyCurrencyTotalTTC
      #     totalHTAvantRemise
      #     totalHTApresRemise
      #     titre
      #     numeroPiece
      #     status
      #     tiersClient {
      #       id
      #       name
      #     }
      #   }
      # }
    }
  `;

  static GET_INVOICE = gql`
    query GetInvoice($id: ID!) {
      invoice(where: { id: $id }) {
        id
        referenceDossier
        address
        tiersClient {
          id
          name
          addresses {
            id
            address
            country {
              id
              label
            }
          }
          client {
            id
            contacts {
              id
              name
              email
            }
            language {
              id
              code
            }
            dateLanguage {
              id
              code
            }
            lastRecipients
            collaboratorRespCom {
              id
              role
              telFixe
              telMobile
              tiers {
                id
                name
                firstname
                lastname
                email                
              }
            }
          }
        }
        taxPieces {
          id
          label
          amount
          taux
          baseHT
          tax {
            id
          }
        }
        status
        expediteur
        date
        dateLivraison
        titre
        creator {
          id
        }
        project {
          id
          name
        }
        currency {
          id
        }
        ttcMode
        totalTTC
        companyCurrencyTotalTTC
        totalHTApresRemise
        memo
        noteInterne
        numeroPiece
        modePaiement
        dateEcheance
        isRecurrence
        periodiciteNombre
        periodiciteType
        invoiceLines {
          id
          sousTotalLine
          article {
            id
            name
            prixVenteHT
          }
          quantity
          remisePourcent
          taxes {
            id
            label
            valuePourcent
          }
          numLine
          description
          prixUnitaireHT
          prixTotalHTApresRemise
        }
        events(orderBy: date_DESC) {
          id
          date
          eventType
          tiers {
            id
            firstname
            lastname
          }
        }
        attachment {
          id
          path
          bucket
          label
          key
        }
        recurrence {
          id
          monthFrequency
          endMonthYear
          generateRealInvoice
          sendInvoice
          lastRecipients
          active
        }
      }
    }
  `;

  static GET_QUOTATION = gql`
    query GetQuotation($id: ID!) {
      quotation(where: { id: $id }) {
        id
        referenceDossier
        address
        tiersClient {
          id
          name
          addresses {
            id
            address
            country {
              id
              label
            }
          }
          currency {
            id
          }
          client {
            id
            language {
              id
              code
            }
            dateLanguage {
              id
              code
            }
            contacts {
              id
              name
              email
            }
            defaultTax1 {
              id
              valuePourcent
              label
            }
            defaultTax2 {
              id
              valuePourcent
              label
            }
          }
        }
        taxPieces {
          id
          label
          amount
          taux
          baseHT
          tax {
            id
          }
        }
        status
        expediteur
        date
        dateValidite
        dateLivraison
        titre
        creator {
          id
        }
        project {
          id
        }
        currency {
          id
        }
        ttcMode
        totalTTC
        totalHTApresRemise
        memo
        noteInterne
        numeroPiece
        acomptePourcent
        acompteHT
        acompteGenerateInvoice

        # modePaiement
        # isRecurrence
        # periodiciteNombre
        # periodiciteType
        quotationLines {
          id
          sousTotalLine
          article {
            id
            name
            description
            prixVenteHT
          }
          quantity
          remisePourcent
          taxes {
            id
            label
            valuePourcent
          }
          numLine
          description
          prixUnitaireHT
          prixTotalHTApresRemise
        }
        events(orderBy: date_DESC) {
          id
          date
          eventType
          tiers {
            id
            firstname
            lastname
          }
        }
        attachment {
          id
          path
          bucket
          label
          key
        }
      }
    }
  `;

  static CREATE_INVOICE_MUTATION = gql`
    mutation CreateInvoice(
      $companyId: ID!
      $creatorId: ID!
      $date: DateTime
      $ttcMode: Boolean
      $dateEcheance: DateTime
      $dateLivraison: DateTime
      $isRecurrence: Boolean
      $memo: String
      $modePaiement: ModeDePaiementEnum
      $periodiciteNombre: Int
      $periodiciteType: PeriodiciteUnite
      $remisePourcent: Float
      $expediteur: String
      $title: String
      $totalHTApresRemise: Float
      $totalTTC: Float
      $companyCurrencyTotalTTC: Float
      $taxPieces: TaxPieceCreateManyWithoutInvoiceInput
      $currencyId: ID!
      $tiersClientId: ID!
      $numeroPiece: String
      $internalRef: Int
      $status: InvoiceStatus
      $referenceDossier: String
      $typeFacture: TypeFactureEnum
      $address: String
    ) {
      createInvoice(
        data: {
          currency: { connect: { id: $currencyId } }
          tiersClient: { connect: { id: $tiersClientId } }
          company: { connect: { id: $companyId } }
          creator: { connect: { id: $creatorId } }
          date: $date
          dateEcheance: $dateEcheance
          dateLivraison: $dateLivraison
          ttcMode: $ttcMode
          isRecurrence: $isRecurrence
          memo: $memo
          modePaiement: $modePaiement
          periodiciteNombre: $periodiciteNombre
          periodiciteType: $periodiciteType
          remisePourcent: $remisePourcent
          expediteur: $expediteur
          titre: $title
          totalHTApresRemise: $totalHTApresRemise
          totalTTC: $totalTTC
          companyCurrencyTotalTTC: $companyCurrencyTotalTTC
          taxPieces: $taxPieces
          status: $status
          numeroPiece: $numeroPiece
          internalRef: $internalRef
          referenceDossier: $referenceDossier
          typeFacture: $typeFacture
          address: $address
        }
      ) {
        id
        referenceDossier
        address
        currency {
          id
        }
        tiersClient {
          id
        }
        date
        dateEcheance
        dateLivraison
        ttcMode
        isRecurrence
        memo
        modePaiement
        periodiciteNombre
        periodiciteType
        remisePourcent
        expediteur
        titre
        totalHTApresRemise
        totalTTC
        companyCurrencyTotalTTC
        numeroPiece
        internalRef
        typeFacture
        attachment {
          id
          bucket
          key
          label
          path
        }
      }
    }
  `;

  static CREATE_QUOTATION_MUTATION = gql`
    mutation CreateQuotation(
      $companyId: ID!
      $creatorId: ID!
      $date: DateTime
      $ttcMode: Boolean
      $dateValidite: DateTime
      $dateLivraison: DateTime
      # $isRecurrence: Boolean
      $memo: String
      # $modePaiement: ModeDePaiementEnum
      # $periodiciteNombre: Int
      # $periodiciteType: PeriodiciteUnite
      $remisePourcent: Float
      $expediteur: String
      $title: String
      $totalHTApresRemise: Float
      $totalTTC: Float
      # $companyCurrencyTotalTTC: Float
      $taxPieces: TaxPieceCreateManyWithoutQuotationInput
      $currencyId: ID!
      $tiersClientId: ID!
      $numeroPiece: String
      $internalRef: Int
      $acomptePourcent: Float
      $acompteHT: Float
      $acompteGenerateInvoice: Boolean
      $referenceDossier: String
      $status: QuotationStatus
      $address: String
    ) {
      createQuotation(
        data: {
          currency: { connect: { id: $currencyId } }
          tiersClient: { connect: { id: $tiersClientId } }
          company: { connect: { id: $companyId } }
          creator: { connect: { id: $creatorId } }
          date: $date
          dateValidite: $dateValidite
          dateLivraison: $dateLivraison
          ttcMode: $ttcMode
          # isRecurrence: $isRecurrence
          memo: $memo
          # modePaiement: $modePaiement
          # periodiciteNombre: $periodiciteNombre
          # periodiciteType: $periodiciteType
          remisePourcent: $remisePourcent
          expediteur: $expediteur
          titre: $title
          totalHTApresRemise: $totalHTApresRemise
          totalTTC: $totalTTC
          # companyCurrencyTotalTTC: $companyCurrencyTotalTTC
          taxPieces: $taxPieces
          status: $status
          numeroPiece: $numeroPiece
          internalRef: $internalRef
          acomptePourcent: $acomptePourcent
          acompteHT: $acompteHT
          acompteGenerateInvoice: $acompteGenerateInvoice
          referenceDossier: $referenceDossier
          address: $address
        }
      ) {
        id
        address
        currency {
          id
        }
        tiersClient {
          id
        }
        date
        dateValidite
        ttcMode
        # isRecurrence
        memo
        # modePaiement
        # periodiciteNombre
        # periodiciteType
        remisePourcent
        expediteur
        titre
        totalHTApresRemise
        totalTTC
        # companyCurrencyTotalTTC
        numeroPiece
        internalRef
        acomptePourcent
        acompteHT
        acompteGenerateInvoice
        referenceDossier
        attachment {
          id
          bucket
          key
          label
          path
        }
      }
    }
  `;
  static getNextInvoiceNumeroPiece = gql`
    query getNextInvoiceNumeroPiece($companyId: ID!, $invoiceDate: DateTime) {
      numeroPiece: getNextInvoiceNumeroPiece(
        where: { company: { id: $companyId }, date: $invoiceDate }
      ) {
        numeroPiece
        internalRef
      }
    }
  `;

  static getNextQuotationNumeroPiece = gql`
    query getNextQuotationNumeroPiece($companyId: ID!, $invoiceDate: DateTime) {
      numeroPiece: getNextQuotationNumeroPiece(
        where: { company: { id: $companyId }, date: $invoiceDate }
      ) {
        numeroPiece
        internalRef
      }
    }
  `;

  static UPDATE_INVOICE_MUTATION = gql`
    mutation UpdateInvoice(
      $id: ID!
      $date: DateTime
      $dateEcheance: DateTime
      $dateLivraison: DateTime
      $ttcMode: Boolean
      $isRecurrence: Boolean
      $memo: String
      $modePaiement: ModeDePaiementEnum
      $periodiciteNombre: Int
      $periodiciteType: PeriodiciteUnite
      $expediteur: String
      $title: String
      $totalHTApresRemise: Float
      $totalTTC: Float
      $companyCurrencyTotalTTC: Float
      $taxPiecesToCreate: [TaxPieceCreateWithoutInvoiceInput!]
      $taxPiecesToUpdate: [TaxPieceUpdateWithWhereUniqueWithoutInvoiceInput!]
      $taxPiecesToDelete: [TaxPieceWhereUniqueInput!]
      $createTaxPieces: Boolean!
      $updateTaxPieces: Boolean!
      $deleteTaxPieces: Boolean!
      $currencyId: ID!
      $tiersClientId: ID!
      $numeroPiece: String
      $internalRef: Int
      $status: InvoiceStatus
      $address: String
      $referenceDossier: String
    ) {
      taxPiecesDeleted: updateInvoice(
        where: { id: $id }
        data: { taxPieces: { delete: $taxPiecesToDelete } }
      ) @include(if: $deleteTaxPieces) {
        id
        taxPieces {
          id
          tax {
            id
          }
        }
      }
      taxPiecesCreated: updateInvoice(
        where: { id: $id }
        data: { taxPieces: { create: $taxPiecesToCreate } }
      ) @include(if: $createTaxPieces) {
        id
        taxPieces {
          id
          tax {
            id
          }
        }
      }
      taxPiecesUpdated: updateInvoice(
        where: { id: $id }
        data: { taxPieces: { update: $taxPiecesToUpdate } }
      ) @include(if: $updateTaxPieces) {
        id
        taxPieces {
          id
        }
      }
      updateInvoice(
        where: { id: $id }
        data: {
          currency: { connect: { id: $currencyId } }
          tiersClient: { connect: { id: $tiersClientId } }
          date: $date
          dateEcheance: $dateEcheance
          dateLivraison: $dateLivraison
          ttcMode: $ttcMode
          isRecurrence: $isRecurrence
          memo: $memo
          modePaiement: $modePaiement
          periodiciteNombre: $periodiciteNombre
          periodiciteType: $periodiciteType
          expediteur: $expediteur
          titre: $title
          totalHTApresRemise: $totalHTApresRemise
          totalTTC: $totalTTC
          companyCurrencyTotalTTC: $companyCurrencyTotalTTC
          status: $status
          numeroPiece: $numeroPiece
          internalRef: $internalRef
          address: $address
          referenceDossier: $referenceDossier
        }
      ) {
        id
        address
        attachment {
          id
          bucket
          key
          label
          path
        }
        currency {
          id
        }
        tiersClient {
          id
        }
        date
        dateEcheance
        dateLivraison
        ttcMode
        isRecurrence
        memo
        modePaiement
        periodiciteNombre
        periodiciteType
        remisePourcent
        expediteur
        titre
        totalHTApresRemise
        totalTTC
        companyCurrencyTotalTTC
        numeroPiece
        internalRef
        referenceDossier
      }
    }
  `;

  static setQuotationStatus = gql`
    mutation setQuotationStatus($id: ID!, $status: QuotationStatus!) {
      updateQuotation(where: { id: $id }, data: { status: $status }) {
        id
        status
      }
    }
  `;

  static setQuotationReferenceDossier = gql`
    mutation setQuotationReferenceDossier($id: ID!, $referenceDossier: String!) {
      updateQuotation(where: { id: $id }, data: { referenceDossier: $referenceDossier }) {
        id
        status
      }
    }
  `;

  static deleteQuotation = gql`
    mutation deleteQuotation($id: ID!) {
      deleteQuotation(where: { id: $id }) {
        id
      }
    }
  `;
  static setQuotationAcceptStatus = gql`
    mutation setQuotationAcceptStatus(
      $id: ID!
      $status: QuotationStatus!
      $dateLivraison: DateTime!
    ) {
      updateQuotation(
        where: { id: $id }
        data: { status: $status, dateLivraison: $dateLivraison }
      ) {
        id
        status
        dateLivraison
      }
    }
  `;

  static UPDATE_QUOTATION_MUTATION = gql`
    mutation UpdateQuotation(
      $id: ID!
      $referenceDossier: String
      $date: DateTime
      $dateValidite: DateTime
      $dateLivraison: DateTime
      $ttcMode: Boolean
      # $isRecurrence: Boolean
      $memo: String
      # $modePaiement: ModeDePaiementEnum
      # $periodiciteNombre: Int
      # $periodiciteType: PeriodiciteUnite
      $expediteur: String
      $title: String
      $totalHTApresRemise: Float
      $totalTTC: Float
      # $companyCurrencyTotalTTC: Float
      $taxPiecesToCreate: [TaxPieceCreateWithoutQuotationInput!]
      $taxPiecesToUpdate: [TaxPieceUpdateWithWhereUniqueWithoutQuotationInput!]
      $taxPiecesToDelete: [TaxPieceWhereUniqueInput!]
      $createTaxPieces: Boolean!
      $updateTaxPieces: Boolean!
      $deleteTaxPieces: Boolean!
      $currencyId: ID!
      $tiersClientId: ID!
      $numeroPiece: String
      $internalRef: Int
      $acomptePourcent: Float
      $acompteHT: Float
      $acompteGenerateInvoice: Boolean
      $status: QuotationStatus
      $address: String
    ) {
      taxPiecesDeleted: updateQuotation(
        where: { id: $id }
        data: { taxPieces: { delete: $taxPiecesToDelete } }
      ) @include(if: $deleteTaxPieces) {
        id
        taxPieces {
          id
        }
      }
      taxPiecesCreated: updateQuotation(
        where: { id: $id }
        data: { taxPieces: { create: $taxPiecesToCreate } }
      ) @include(if: $createTaxPieces) {
        id
        taxPieces {
          id
        }
      }
      taxPiecesUpdated: updateQuotation(
        where: { id: $id }
        data: { taxPieces: { update: $taxPiecesToUpdate } }
      ) @include(if: $updateTaxPieces) {
        id
        taxPieces {
          id
        }
      }
      updateQuotation(
        where: { id: $id }
        data: {
          currency: { connect: { id: $currencyId } }
          tiersClient: { connect: { id: $tiersClientId } }
          referenceDossier: $referenceDossier
          date: $date
          dateValidite: $dateValidite
          dateLivraison: $dateLivraison
          ttcMode: $ttcMode
          # isRecurrence: $isRecurrence
          memo: $memo
          # modePaiement: $modePaiement
          # periodiciteNombre: $periodiciteNombre
          # periodiciteType: $periodiciteType
          expediteur: $expediteur
          titre: $title
          totalHTApresRemise: $totalHTApresRemise
          totalTTC: $totalTTC
          # companyCurrencyTotalTTC: $companyCurrencyTotalTTC
          status: $status
          numeroPiece: $numeroPiece
          internalRef: $internalRef
          acomptePourcent: $acomptePourcent
          acompteHT: $acompteHT
          acompteGenerateInvoice: $acompteGenerateInvoice
          address: $address
        }
      ) {
        id
        referenceDossier
        address
        attachment {
          id
          bucket
          key
          label
          path
        }
        currency {
          id
        }
        tiersClient {
          id
        }
        date
        dateValidite
        # dateLivraison
        ttcMode
        # isRecurrence
        memo
        # modePaiement
        # periodiciteNombre
        # periodiciteType
        remisePourcent
        expediteur
        titre
        totalHTApresRemise
        totalTTC
        # companyCurrencyTotalTTC
        numeroPiece
        internalRef
        acomptePourcent
        acompteHT
        acompteGenerateInvoice
      }
    }
  `;

  static CONNECT_INVOICE_WITH_PROJECT = gql`
    mutation CreateInvoiceConnections($id: ID!, $projectId: ID!) {
      project: updateInvoice(
        where: { id: $id }
        data: { project: { connect: { id: $projectId } } }
      ) {
        id
        project {
          id
        }
      }
    }
  `;

  static DISCONNECT_INVOICE_PROJECT = gql`
    mutation DisconnectInvoiceProject($id: ID!) {
      project: updateInvoice(
        where: { id: $id }
        data: { project: { disconnect: true } }
      ) {
        id
        project {
          id
        }
      }
    }
  `;

  static DISCONNECT_QUOTATION_PROJECT = gql`
    mutation DisconnectInvoiceConnections($id: ID!) {
      project: updateQuotation(
        where: { id: $id }
        data: { project: { disconnect: true } }
      ) {
        id
        project {
          id
        }
      }
    }
  `;

  static CONNECT_QUOTATION_WITH_PROJECT = gql`
    mutation CreateQuotationConnections($id: ID!, $projectId: ID!) {
      project: updateQuotation(
        where: { id: $id }
        data: { project: { connect: { id: $projectId } } }
      ) {
        id
        project {
          id
        }
      }
    }
  `;
  static CREATE_INVOICE_LINE_MUTATION = gql`
    mutation CreateInvoiceLine(
      $invoiceId: ID!
      $description: String
      $numLine: Int
      $sousTotalLine: Boolean
      $prixUnitaireHT: Float
      $prixTotalHTAvantRemise: Float
      $prixTotalHTApresRemise: Float
      $quantity: Float
      $remisePourcent: Float
    ) {
      createInvoiceLine(
        data: {
          invoice: { connect: { id: $invoiceId } }
          sousTotalLine: $sousTotalLine
          description: $description
          numLine: $numLine
          prixUnitaireHT: $prixUnitaireHT
          prixTotalHTAvantRemise: $prixTotalHTAvantRemise
          prixTotalHTApresRemise: $prixTotalHTApresRemise
          quantity: $quantity
          remisePourcent: $remisePourcent
        }
      ) {
        id
      }
    }
  `;

  static CREATE_QUOTATION_LINE_MUTATION = gql`
    mutation CreateQuotationLine(
      $quotationId: ID!
      $description: String
      $numLine: Int
      $sousTotalLine: Boolean
      $prixUnitaireHT: Float
      $prixTotalHTAvantRemise: Float
      $prixTotalHTApresRemise: Float
      $quantity: Float
      $remisePourcent: Float
    ) {
      createQuotationLine(
        data: {
          quotation: { connect: { id: $quotationId } }
          sousTotalLine: $sousTotalLine
          description: $description
          numLine: $numLine
          prixUnitaireHT: $prixUnitaireHT
          prixTotalHTAvantRemise: $prixTotalHTAvantRemise
          prixTotalHTApresRemise: $prixTotalHTApresRemise
          quantity: $quantity
          remisePourcent: $remisePourcent
        }
      ) {
        id
      }
    }
  `;

  static CONNECT_INVOICE_LINE_MUTATION = gql`
    mutation connectInvoiceLine(
      $invoiceLineId: ID!
      $connectTaxes: Boolean!
      $disconnectTaxes: Boolean!
      $connectArticle: Boolean!
      $taxesToConnect: [TaxWhereUniqueInput!]
      $taxesToDisconnect: [TaxWhereUniqueInput!]
      $articleId: ID
    ) {
      taxesDisconnected: updateInvoiceLine(
        where: { id: $invoiceLineId }
        data: { taxes: { disconnect: $taxesToDisconnect } }
      ) @include(if: $disconnectTaxes) {
        id
        taxes {
          id
          label
          valuePourcent
        }
      }
      taxesConnected: updateInvoiceLine(
        where: { id: $invoiceLineId }
        data: { taxes: { connect: $taxesToConnect } }
      ) @include(if: $connectTaxes) {
        id
        taxes {
          id
          label
          valuePourcent
        }
      }
      article: updateInvoiceLine(
        where: { id: $invoiceLineId }
        data: { article: { connect: { id: $articleId } } }
      ) @include(if: $connectArticle) {
        id
        article {
          id
        }
      }
    }
  `;

  static CONNECT_QUOTATION_LINE_MUTATION = gql`
    mutation connectQuotationLine(
      $quotationLineId: ID!
      $connectTaxes: Boolean!
      $disconnectTaxes: Boolean!
      $connectArticle: Boolean!
      $taxesToConnect: [TaxWhereUniqueInput!]
      $taxesToDisconnect: [TaxWhereUniqueInput!]
      $articleId: ID
    ) {
      taxesDisconnected: updateQuotationLine(
        where: { id: $quotationLineId }
        data: { taxes: { disconnect: $taxesToDisconnect } }
      ) @include(if: $disconnectTaxes) {
        id
        taxes {
          id
          label
          valuePourcent
        }
      }
      taxesConnected: updateQuotationLine(
        where: { id: $quotationLineId }
        data: { taxes: { connect: $taxesToConnect } }
      ) @include(if: $connectTaxes) {
        id
        taxes {
          id
          label
          valuePourcent
        }
      }
      article: updateQuotationLine(
        where: { id: $quotationLineId }
        data: { article: { connect: { id: $articleId } } }
      ) @include(if: $connectArticle) {
        id
        article {
          id
        }
      }
    }
  `;

  static UPDATE_INVOICE_LINE_MUTATION = gql`
    mutation UpdateInvoiceLine(
      $id: ID!
      $description: String
      $numLine: Int
      $sousTotalLine: Boolean
      $prixUnitaireHT: Float
      $prixTotalHTAvantRemise: Float
      $prixTotalHTApresRemise: Float
      $quantity: Float
      $remisePourcent: Float
    ) {
      updateInvoiceLine(
        where: { id: $id }
        data: {
          sousTotalLine: $sousTotalLine
          description: $description
          numLine: $numLine
          prixUnitaireHT: $prixUnitaireHT
          prixTotalHTAvantRemise: $prixTotalHTAvantRemise
          prixTotalHTApresRemise: $prixTotalHTApresRemise
          quantity: $quantity
          remisePourcent: $remisePourcent
        }
      ) {
        id
      }
    }
  `;

  static UPDATE_QUOTATION_LINE_MUTATION = gql`
    mutation UpdateQuotationLine(
      $id: ID!
      $description: String
      $numLine: Int
      $sousTotalLine: Boolean
      $prixUnitaireHT: Float
      $prixTotalHTAvantRemise: Float
      $prixTotalHTApresRemise: Float
      $quantity: Float
      $remisePourcent: Float
    ) {
      updateQuotationLine(
        where: { id: $id }
        data: {
          sousTotalLine: $sousTotalLine
          description: $description
          numLine: $numLine
          prixUnitaireHT: $prixUnitaireHT
          prixTotalHTAvantRemise: $prixTotalHTAvantRemise
          prixTotalHTApresRemise: $prixTotalHTApresRemise
          quantity: $quantity
          remisePourcent: $remisePourcent
        }
      ) {
        id
      }
    }
  `;

  static payInvoices = gql`
    mutation PayInvoices(
      $invoiceIds: [ID]!
      $bankTransactionEcritureLineIds: [ID]
      $bankAccountId: ID!
      $datePay: DateTime
      $paymentLibelle: String
    ) {
      payInvoices(
        where: {
          invoiceIds: $invoiceIds
          bankTransactionEcritureLineIds: $bankTransactionEcritureLineIds
          bankAccountId: $bankAccountId
          datePay: $datePay
        }
        data: { paymentLibelle: $paymentLibelle }
      ) {
        id
      }
    }
  `;

  static relanceInvoices = gql`
    mutation relanceInvoices(
      $emails: [String]
      $ccEmails: [String]
      $bccEmails: [String]
      $mailObject: String
      $mailContent: String
      $invoiceIds: [ID]!
      $bankTransactionEcritureLineIds: [ID]
      $translations: [translatedIDS]
    ) {
      relanceInvoices(   
        invoiceIds: $invoiceIds
        bankTransactionEcritureLineIds: $bankTransactionEcritureLineIds
        emails: $emails
        ccEmails: $ccEmails
        bccEmails: $bccEmails
        mailObject: $mailObject
        mailContent: $mailContent
        translations: $translations
      ) {
        result
      }
    }
  `;

  static createInvoicesEcritures = gql`
    mutation createInvoicesEcritures(
      $invoiceIds: [ID]!
      $bankTransactionEcritureLineIds: [ID]
      $bankTransactionId: ID
    ) {
      createInvoicesEcritures(
        where: {
          invoiceIds: $invoiceIds
          bankTransactionEcritureLineIds: $bankTransactionEcritureLineIds
          bankTransactionId: $bankTransactionId
        }
      ) {
        result
      }
    }
  `;

  // static UPDATE_INVOICE_SUB_TOTAL_MUTATION = gql`
  //   mutation UpdateInvoiceLine(
  //     $id: ID!
  //     $description: String
  //     $sousTotalLine: Boolean
  //     $prixTotalHT: Float
  //     $numLine: Int
  //   ) {
  //     updateInvoiceLine(
  //       where: { id: $id }
  //       data: {
  //         sousTotalLine: $sousTotalLine
  //         description: $description
  //         numLine: $numLine
  //         prixTotalHT: $prixTotalHT
  //       }
  //     ) {
  //       id
  //     }
  //   }
  // `;

  static DELETE_INVOICE_MUTATION = gql`
    mutation DeleteInvoice($id: ID!) {
      updateInvoice(where: { id: $id }, data: { isDeleted: true }) {
        id
      }
    }
  `;

  static DELETE_QUOTATION_MUTATION = gql`
    mutation DeleteQuotation($id: ID!) {
      updateQuotation(where: { id: $id }, data: { isDeleted: true }) {
        id
      }
    }
  `;

  static DELETE_INVOICE_LINE_MUTATION = gql`
    mutation DeleteInvoiceLine($id: ID!) {
      deleteInvoiceLine(where: { id: $id }) {
        id
      }
    }
  `;

  static DELETE_QUOTATION_LINE_MUTATION = gql`
    mutation DeleteQuotationLine($id: ID!) {
      deleteQuotationLine(where: { id: $id }) {
        id
      }
    }
  `;

  static getAcompteArticle = gql`
    query getAcompteArticle($companyId: ID!) {
      acompteArticle: articles(
        where: { AND: [{ company: { id: $companyId } }, { acompte: true }] }
      ) {
        id
        acompte
        name
        description
      }
    }
  `;

  static getOdooImportList = gql`
    query getOdooImportList($companyId: ID!) {
      getOdooImportList(companyId: $companyId) {        
        id
        fileName   
        format
        dateImport
        result
        failureCause
        fileKey
        fileUrl
        uploader   
      }
    }
  `;

  static getOdooImportFormatList = gql`
    query getOdooImportFormatList($companyId: ID!) {
      getOdooImportFormatList(companyId: $companyId) {        
        id
        name        
      }
    }
  `;

  static GET_ALL_EXPORT_WO_FILTER = gql`
    query GetAllExports($companyId: ID!) {
      _allExportsMeta(
        where: { AND: [{ company: { id: $companyId } }] }
      ) {
        count
      }
      company(where: { id: $companyId }) {
        id
        exports(orderBy: dateExport_DESC) {
          id
          label
          path
          key
          path2
          key2
          path3
          key3
          bucket
          tiers {
            id
            name
          }
          dateExport
          periodeDebut
          periodeFin
          journalCode
          count
          total
          lastDownloadDate
        }
      }
    }
  `;

  static GET_ALL_EXPORT = gql`
    query GetAllExports($companyId: ID!, $filter: ExportWhereInput!) {
      _allExportsMeta(
        where: { AND: [$filter, { company: { id: $companyId } }] }
      ) {
        count
      }
      company(where: { id: $companyId }) {
        id
        exports(orderBy: dateExport_DESC, where: $filter) {
          id
          label
          path
          key
          path2
          key2
          path3
          key3
          bucket
          tiers {
            id
            name
          }
          dateExport
          periodeDebut
          periodeFin
          journalCode
          count
          total
          lastDownloadDate
        }
      }
    }
  `;

  static BUILD_EXPORT_MUTATION = gql`
    mutation BuildExport(
      $companyId: ID!
      $creatorId: ID
      $bankAccounts: [BankAccountWhereUniqueInput!]
      $allOperations: Boolean
      $dateExport: DateTime
      $dateAu: DateTime
      $dateDu: DateTime
      $depensesStatus: Boolean
      $ventesStatus: Boolean
      $ecartsStatus: Boolean
    ) {
      buildExport(
        companyId: $companyId
        creatorId: $creatorId
        bankAccounts: $bankAccounts
        allOperations: $allOperations
        dateExport: $dateExport
        dateAu: $dateAu
        dateDu: $dateDu
        depensesStatus: $depensesStatus
        ventesStatus: $ventesStatus
        ecartsStatus: $ecartsStatus
      ) {
        id
      }
    }
  `;

  static DELETE_EXPORT_MUTATION = gql`
    mutation DeleteExport(
      $companyId: ID!
      $exportId: ID
    ) {
      deleteExport(
        companyId: $companyId
        exportId: $exportId
      ) {
        result
      }
    }
  `;

  // static IMPORT_TO_ODOO_MUTATION = gql`
  //   mutation ImportToOdoo(
  //     $companyId: ID!
  //     $exportId: ID
  //     $locale: String
  //   ) {
  //     importToOdoo(
  //       companyId: $companyId
  //       exportId: $exportId
  //       locale: $locale
  //     ) {
  //       result
  //     }
  //   }
  // `;



  static createAcompteArticle = gql`
    mutation createAcompteArticle($companyId: ID!, $name: String) {
      acompteArticle: createArticle(
        data: {
          acompte: true
          company: { connect: { id: $companyId } }
          name: $name
          active: true
        }
      ) {
        id
        acompte
        name
        active
        company {
          id
        }
      }
    }
  `;

  static getArticle = gql`
    query getArticle($articleId: ID!) {
      article(where: { id: $articleId }) {
        id
        name
        description
        tagArticle
        prixVenteHT
        active
        category {
          id
          ids
          name
        }
      }
    }
  `;

  static GET_ALL_ARTICLES = gql`
    query getAllArticles($companyId: ID!) {
      company(where: { id: $companyId }) {
        id
        articles(where: { active: true }, orderBy: name_ASC) {
          id
          active
          name
          unitArticle
          prixVenteHT
          description
        }
      }
    }
  `;

  static createArticle = gql`
    mutation CreateArticle(
      $companyId: ID!
      $name: String!
      $description: String
      $prixVenteHT: Float
      $tagArticle: String
      $active: Boolean
    ) {
      createArticle(
        data: {
          name: $name
          description: $description
          prixVenteHT: $prixVenteHT
          tagArticle: $tagArticle
          company: { connect: { id: $companyId } }
          active: $active
        }
      ) {
        id
        name
        description
        prixVenteHT
        tagArticle
        company {
          id
        }
        active
      }
    }
  `;

  static updateArticle = gql`
    mutation updateArticle(
      $articleId: ID!
      $name: String!
      $description: String
      $prixVenteHT: Float
      $tagArticle: String
      $active: Boolean
    ) {
      updateArticle(
        where: { id: $articleId }
        data: {
          name: $name
          description: $description
          prixVenteHT: $prixVenteHT
          tagArticle: $tagArticle
          active: $active
        }
      ) {
        id
      }
    }
  `;

  static connectArticle = gql`
    mutation connectArticle(
      $articleId: ID!
      $categoryId: ID!
      $connectCategory: Boolean!
    ) {
      updateArticle(
        where: { id: $articleId }
        data: { category: { connect: { id: $categoryId } } }
      ) @include(if: $connectCategory) {
        id
        category {
          id
        }
      }
    }
  `;

  static ARTICLE_LIST_QUERY = gql`
    query GET_ARTICLES(
      $orderBy: ArticleOrderByInput
      $where: ArticleWhereInput
      $filterCount: ArticleWhereInput
      $skip: Int!
      $first: Int!
    ) {
      _articlesMeta(where: $filterCount) {
        count
      }
      articles(first: $first, skip: $skip, orderBy: $orderBy, where: $where) {
        id
        name
        typeArticle
        description
        tagArticle
        category {
          id
          ids
          name
        }
        prixVenteHT
        prixRevientHT # to process mark-up locally
        active
      }
    }
  `;

  static GET_TAG_ARTICLES = gql`
    query GET_TAG_ARTICLES($companyId: ID!) {
      tagArticles: articles(
        where: { company: { id: $companyId }, tagArticle_not: "" }
      ) {
        tagArticle
      }
    }
  `;

  static CHECK_MAIL_COLLABORATOR_MUTATION = gql`
    mutation checkMailCollaborator($companyId: ID!, $id: ID, $email: String) {
      checkMailCollaborator(companyId: $companyId, id: $id, email: $email) {
        result
      }
    }
  `;

  static CREATE_COLLABORATOR_MUTATION = gql`
    mutation CreateCollaborator(
      $companyId: ID!
      $email: String
      $firstName: String = ""
      $lastName: String = ""
      $name: String = ""
      $fixPhone: String = ""
      $mobilePhone: String = ""
      $iban: String = ""
      $swift: String = ""
      $currency: ID
      $role: RoleEnum
      $invite: Boolean
      $xtraData: String
      # $notifBankTransactions: Boolean
      # $notifBankAlerts: Boolean
    ) {
      # $userCompanyIds: [ID!]
      createTiers(
        data: {
          email: $email
          firstname: $firstName
          lastname: $lastName
          name: $name
          iban: $iban
          swift: $swift
          xtraData: $xtraData
          currency: { connect: { id: $currency } }
          company: { connect: { id: $companyId } }
          collaborator: {
            create: {
              telFixe: $fixPhone
              telMobile: $mobilePhone
              role: $role
              invite: $invite
            }
          }
        }
      ) {
        firstname
        lastname
        name
        email
        id
        xtraData
        collaborator {
          id
          telFixe
          telMobile
          role
          invite
        }
      }
    }
  `;

  static getAllCategories = gql`
    query getAllCategories($where: CategoryWhereInput, $companyId: ID!) {
      categories(orderBy: name_ASC, where: $where) {
        id
        ids
        name
        active
        company {
          id
        }
        companySettings(where: { company: { id: $companyId } }) {
          id
          active
          company {
            id
            name
          }
        }
        categoriesParent {
          id
          ids
          name
        }
        categoryFamily {
          id
          ids
          name
        }
        ecritureLines(
          first: 1, skip: 0,
          where: {
            company: { id: $companyId }
            amount_not: 0
          }
        ) {
          id
        }
      }
    }
  `;

  static getCompanySettings = gql`
    query getCompanySettings($companyId: ID!, $active: Boolean) {
      companyCategorySettings(
        where: { AND: [{ company: { id: $companyId } }, { active: $active }] }
      ) {
        id
        active
        category {
          id
        }
      }
    }
  `;

  static getCategories = gql`
    query getCategories(
      $companyId: ID!
      $tiers: String
      $tiersCategory: Boolean = false
      $expenseCategory: Boolean = false
      $supplierCategory: Boolean = false
      $clientCategory: Boolean = false
      $collaboratorCategory: Boolean = false
      $invoiceCategory: Boolean = false
    ) {
      expense: categories(
        orderBy: name_ASC
        where: {
          AND: [
            { categoryFamily: { expenseCategory: $expenseCategory } }
            { OR: [{ company: null }, { company: { id: $companyId } }] }
          ]
        }
      ) @include(if: $expenseCategory) {
        ...categoryInfo
      }
      supplier: categories(
        orderBy: name_ASC
        where: {
          AND: [
            { categoryFamily: { supplierCategory: $supplierCategory } }
            { OR: [{ company: null }, { company: { id: $companyId } }] }
          ]
        }
      ) @include(if: $supplierCategory) {
        ...categoryInfo
      }
      client: categories(
        orderBy: name_ASC
        where: {
          AND: [
            { categoryFamily: { clientCategory: $clientCategory } }
            { OR: [{ company: null }, { company: { id: $companyId } }] }
          ]
        }
      ) @include(if: $clientCategory) {
        ...categoryInfo
      }
      collaborator: categories(
        orderBy: name_ASC
        where: {
          AND: [
            { categoryFamily: { collaboratorCategory: $collaboratorCategory } }
            { OR: [{ company: null }, { company: { id: $companyId } }] }
          ]
        }
      ) @include(if: $collaboratorCategory) {
        ...categoryInfo
      }
      tierses: categories(
        orderBy: name_ASC
        where: {
          AND: [
            {
              categoryFamily: {
                name_in: ["Fournisseurs", "Clients", "Collaborateurs"]
              }
            }
            { OR: [{ company: null }, { company: { id: $companyId } }] }
          ]
        }
      ) @include(if: $tiersCategory) {
        ...categoryInfo
      }
      tiers: categories(
        orderBy: name_ASC
        where: {
          AND: [
            { categoryFamily: { name: $tiers } }
            { OR: [{ company: null }, { company: { id: $companyId } }] }
          ]
        }
      ) {
        ...categoryInfo
      }
      invoice: categories(
        orderBy: name_ASC
        where: {
          AND: [
            { categoryFamily: { invoiceCategory: $invoiceCategory } }
            { OR: [{ company: null }, { company: { id: $companyId } }] }
          ]
        }
      ) @include(if: $invoiceCategory) {
        ...categoryInfo
      }
    }

    fragment categoryInfo on Category {
      id
      ids
      name
      auxiliarisable
      fluxTresorerie
      lettrageAuto
      sensHabituel
      categoryFamily {
        id
        ids
        name
        reportRentability
      }
      categoriesParent {
        id
        name
      }
      account {
        id
      }
      company {
        id
      }
    }
  `;

  static getCategory = gql`
    query getCategories($categoryId: ID, $companyId: ID!) {
      category: categories(where: { id: $categoryId }) {
        id
        ids
        name
        companySettings(where: { company: { id: $companyId } }) {
          id
          active
        }
        company {
          id
          name
        }
        categoryFamily {
          id
          ids
          administrable
        }
        account {
          id
        }
        categoriesParent {
          id
          ids
          name
          lettrageAuto
          fluxTresorerie
          auxiliarisable
          sensHabituel
          account {
            id
          }
          categoryFamily {
            id
            ids
          }
        }
        ecritureLines(first: 1, skip: 0) {
          id
        }
        budgetItems(first: 1, skip: 0) {
          id
        }
      }
    }
  `;

  static createCategory = gql`
    mutation updateCompany(
      $categoryName: String
      $categoriesParentId: ID
      $companyId: ID!
      $lettrageAuto: Boolean
      $fluxTresorerie: Boolean
      $auxiliarisable: Boolean
      $sensHabituel: SensHabituelEnum
      $accountId: ID
      $categoryFamilyId: ID
    ) {
      updateCompany(
        where: { id: $companyId }
        data: {
          categories: {
            create: [
              {
                name: $categoryName
                categoriesParent: { connect: { id: $categoriesParentId } }
                fluxTresorerie: $fluxTresorerie
                lettrageAuto: $lettrageAuto
                auxiliarisable: $auxiliarisable
                sensHabituel: $sensHabituel
                categoryFamily: { connect: { id: $categoryFamilyId } }
                companySettings: {
                  create: [
                    { active: true, company: { connect: { id: $companyId } } }
                  ]
                }
                account: { connect: { id: $accountId } }
              }
            ]
          }
        }
      ) {
        id
        categories {
          id
          ids
          name
          auxiliarisable
          fluxTresorerie
          lettrageAuto
          sensHabituel
          categoryFamily {
            id
            ids
            name
          }
          companySettings {
            id
            active
            company {
              id
            }
          }

          account {
            id
          }
        }
      }
    }
  `;

  static getCategoriesForBudget = gql`
    query categories(
      $companyId: ID!
      $categoryId: ID!
      $first: Int
      $skip: Int
    ) {
      getCategoriesForBudget(
        companyId: $companyId
        categoryId: $categoryId
        first: $first
        skip: $skip
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        aggregate {
          count
        }
        edges {
          node {
            id
            ids
            generic
            categoriesParent {
              id
              ids
              name
            }
            categoryFamily {
              id
              ids
            }
            company {
              id
              currency {
                id
              }
            }
            name
            budgetCurrent
            budgetNext
            budgetTiersSupplier {
              id
              name
              client {
                id
              }
              supplier {
                id
              }
              collaborator {
                id
              }
            }
            budgetTiersClient {
              id
              name
            }
            budgetProject {
              id
              name
            }
            budgetIsReal
            # budgetClientProject
          }
        }
      }
    }
  `;

  static getClientsForBudget = gql`
    query clients($companyId: ID!, $tiersId: ID!, $first: Int, $skip: Int) {
      getClientsForBudget(
        companyId: $companyId
        tiersId: $tiersId
        first: $first
        skip: $skip
      ) {
        aggregate {
          count
        }
        edges {
          node {
            id
            name
            budgetCurrent
            budgetNext
            group
            company {
              id
              currency {
                id
              }
            }
            client {
              id
              collaboratorRespCom {
                id
		            role
                telFixe
                telMobile
                tiers {
                  id
                  name
                  firstname
                  lastname
                  email                
                }
              }
            }
            budgetProject {
              id
              name
            }
            budgetIsReal
          }
        }
      }
    }
  `;

  static updateCompanyCategorySetting = gql`
    mutation updateCompanyCategorySetting(
      $id: ID
      $data: CompanyCategorySettingUpdateInput!
    ) {
      updateCompanyCategorySetting(where: { id: $id }, data: $data) {
        id
        active
      }
    }
  `;

  static deleteCompanyCategorySetting = gql`
    mutation deleteCompanyCategorySetting($companySettingsId: ID) {
      deleteCompanyCategorySetting(where: { id: $companySettingsId }) {
        id
      }
    }
  `;

  static updateCompanyCodeJournal = gql`
    mutation updateCompanyCodeJournal(
      $id: ID!
      $codeExportAchat: String
      $codeExportVente: String
      $codeExportEcart: String
    ) {
      updateCompany(
        where: { id: $id }
        data: {
          codeExportAchat: $codeExportAchat
          codeExportVente: $codeExportVente
          codeExportEcart: $codeExportEcart
        }
      ) {
        id
      }
    }
  `;

  static updateCategory = gql`
    mutation updateCompany(
      $categoryName: String
      $categoryId: ID
      $companyId: ID
      $parentId: ID #    $categoryActive: Boolean
      $lettrageAuto: Boolean
      $fluxTresorerie: Boolean
      $auxiliarisable: Boolean
      $sensHabituel: SensHabituelEnum
      $accountId: ID
      $categoryFamilyId: ID
    ) {
      updateCompany(
        where: { id: $companyId }
        data: {
          categories: {
            update: [
              {
                where: { id: $categoryId }
                data: {
                  categoriesParent: { connect: { id: $parentId } }
                  name: $categoryName
                  #active: $categoryActive
                  fluxTresorerie: $fluxTresorerie
                  lettrageAuto: $lettrageAuto
                  auxiliarisable: $auxiliarisable
                  sensHabituel: $sensHabituel
                  categoryFamily: { connect: { id: $categoryFamilyId } }
                  account: { connect: { id: $accountId } }
                }
              }
            ]
          }
        }
      ) {
        id
        categories {
          id
          ids
          name
          auxiliarisable
          fluxTresorerie
          lettrageAuto
          sensHabituel
          categoryFamily {
            id
            ids
            name
          }
          companySettings {
            id
            active
          }
          account {
            id
          }
        }
      }
    }
  `;

  static deleteCategory = gql`
    mutation deleteCategory($categoryId: ID) {
      deleteCategory(where: { id: $categoryId }) {
        id
      }
    }
  `;

  static getCompanyLogoAndFooter = gql`
    query GetCompanyLogoAndFooter($companyId: ID!) {
      myCompanies(where2: { id: $companyId }) {
        id
        name
        addresses {
          id
          address
        }
        footer
        # logoes {
        #   id
        #   path
        # }
      }
    }
  `;

  static getCategoriesForNewArticleForm = gql`
    query GetCategoriesForNewArticle($categoryFamilyId: ID) {
      categories(where: { categoryFamily: { id: $categoryFamilyId } }) {
        id
        name
      }
    }
  `;

  static GET_CURRENCIES = gql`
    query GetCurrencies {
      currencies {
        id
        code
        symbol
        decimalSeparator
        thousandSeparator
      }
    }
  `;

  static getCompanyForDocumentSettingsForm = gql`
    query getCompanyForDocumentSettingsForm($companyId: ID!) {
      company: company(where: { id: $companyId }) {
        id
        footer
        documents {
          id
          language {
            id
            code
            label
          }
          conditionsDeVente
          pdfCgvLabel
          pdfCgvPath
          pdfCgvKey
          pdfCgvBucket
          
          subjectQuotation
          bodyQuotation
          subjectInvoice
          bodyInvoice
          subjectRelance
          bodyRelance
        }
        versionPDF
        formatPDF
        firmColor
      }
      language: language(where: { code: "FR" }) {
        id
        code
      }
      languageEN: language(where: { code: "EN" }) {
        id
        code
      }
      languageNL: language(where: { code: "NL" }) {
        id
        code
      }
      languageDE: language(where: { code: "DE" }) {
        id
        code
      }
    }
  `;

  static getCompanyForCompanyEditForm = gql`
    query getCompanyForCompanyEditForm($companyId: ID!) {
      company(where: { id: $companyId }) {
        id
        aliasMailNetwips
        name
        addresses {
          id
          address
          zipCode
          city
          country {
            id
          }
        }
        currency {
          id
        }        
        logoes {
          id
          path
          key
          bucket
          nw1Ref
        }
        isTaxActive
        tax1 {
          id
          label
          valuePourcent
        }
        tax2 {
          id
          label
          valuePourcent
        }
        formeJuridique
        planComptableCharCount
        defaultClientAccountLabel
        defaultSupplierAccountLabel
        defaultCollaboratorAccountLabel
        homepage
        siret
        siren
        codeAPE
        numeroTVA
        villeRCS
        capitalSocial
        telFixe
        telMobile
        invoiceQuotationCompteurMode
        invoiceStartIndex
        quotationStartIndex
        formatNumeroPiece
        checkoutCustomerId
        planId
        relanceAvantPaiement
        relanceAvantFormatTxt
        relanceApresPaiement
        relanceApresFormatTxt
      }
    }
  `;

  static updateCompany = gql`
    mutation updatecompany(
      $companyId: ID!
      $name: String
      $addressId: ID!
      $address: String
      $city: String
      $currencyId: ID
      $countryId: ID
      $formeJuridique: String
      $homepage: String
      $planComptableCharCount: Int
      $defaultClientAccountLabel: String
      $defaultSupplierAccountLabel: String
      $defaultCollaboratorAccountLabel: String
      $siret: String
      $siren: String
      $codeAPE: String
      $numeroTVA: String
      $villeRCS: String
      $capitalSocial: String
      $telFixe: String
      $telMobile: String
    ) {
      # $zipcode: String, # $isTaxActive
      updateAddress(
        where: { id: $addressId }
        data: { address: $address, city: $city, country: { id: $countryId } }
      ) {
        # zipCode: $zipcode,updateCo
        id
        address
        city
        country {
          id
        }
      }

      updateCompany(
        where: { id: $companyId }
        data: {
          name: $name
          currency: { connect: { id: $currencyId } }
          formeJuridique: $formeJuridique
          homepage: $homepage
          planComptableCharCount: $planComptableCharCount
          defaultClientAccountLabel: $defaultClientAccountLabel
          defaultSupplierAccountLabel: $defaultSupplierAccountLabel
          defaultCollaboratorAccountLabel: $defaultCollaboratorAccountLabel
          siret: $siret
          siren: $siren
          codeAPE: $codeAPE
          numeroTVA: $numeroTVA
          villeRCS: $villeRCS
          capitalSocial: $capitalSocial
          telFixe: $telFixe
          telMobile: $telMobile
        }
      ) {
        # isTaxActive
        id
        name
        currency {
          id
        }
        addresses {
          id
        }
        # isTaxActive
        formeJuridique
        homepage
        planComptableCharCount
        defaultClientAccountLabel
        defaultSupplierAccountLabel
        defaultCollaboratorAccountLabel
        siret
        siren
        codeAPE
        numeroTVA
        villeRCS
        capitalSocial
        telFixe
        telMobile
      }
    }
  `;

  static updateCompanyDefaultTaxes = gql`
    mutation updateCompanyDefaultTaxes(
      $companyId: ID!
      $connectTax1: Boolean!
      $disconnectTax1: Boolean!
      $connectTax2: Boolean!
      $disconnectTax2: Boolean!
      $tax1Id: ID
      $tax2Id: ID
    ) {
      tax1: updateCompany(
        where: { id: $companyId }
        data: { tax1: { connect: { id: $tax1Id } } }
      ) @include(if: $connectTax1) {
        id
        tax1 {
          id
        }
      }
      tax1Disconnected: updateCompany(
        where: { id: $companyId }
        data: { tax1: { disconnect: $disconnectTax1 } }
      ) @include(if: $disconnectTax1) {
        id
        tax1 {
          id
        }
      }
      tax2: updateCompany(
        where: { id: $companyId }
        data: { tax2: { connect: { id: $tax2Id } } }
      ) @include(if: $connectTax2) {
        id
        tax2 {
          id
        }
      }
      tax2Disconnected: updateCompany(
        where: { id: $companyId }
        data: { tax2: { disconnect: $disconnectTax2 } }
      ) @include(if: $disconnectTax2) {
        id
        tax2 {
          id
        }
      }
    }
  `;

  static updateCompanyForEditPage = gql`
    mutation updateCompany(
      $aliasMailNetwips: String
      $companyId: ID!
      $name: String
      $address: String
      $addressId: ID!
      $city: String
      $currencyId: ID
      $countryId: ID
      $formeJuridique: String
      $homepage: String
      $planComptableCharCount: Int
      $defaultClientAccountLabel: String
      $defaultSupplierAccountLabel: String
      $defaultCollaboratorAccountLabel: String
      $siret: String
      $siren: String
      $codeAPE: String
      $numeroTVA: String
      $villeRCS: String
      $capitalSocial: String
      $telFixe: String
      $telMobile: String
      $connectTax1: Boolean!
      $disconnectTax1: Boolean!
      $connectTax2: Boolean!
      $disconnectTax2: Boolean!
      $tax1Id: ID
      $tax2Id: ID
      $invoiceQuotationCompteurMode: CompteurModeEnum
      $invoiceStartIndex: Int
      $quotationStartIndex: Int
      $formatNumeroPiece: String
      $relanceAvantPaiement: Boolean
      $relanceAvantFormatTxt: String
      $relanceApresPaiement: Boolean
      $relanceApresFormatTxt: String
    ) {
      # $zipcode: String, # $isTaxActive
      updateAddress(
        where: { id: $addressId }
        data: {
          address: $address
          city: $city
          country: { connect: { id: $countryId } }
        }
      ) {
        # zipCode: $zipcode,
        id
        address
        # zipCode
        city
        country {
          id
          label
        }
      }
      updateCompany(
        updateAccountingPlan: true
        where: { id: $companyId }
        data: {
          aliasMailNetwips: $aliasMailNetwips
          name: $name
          currency: { connect: { id: $currencyId } }
          formeJuridique: $formeJuridique
          homepage: $homepage
          planComptableCharCount: $planComptableCharCount
          defaultClientAccountLabel: $defaultClientAccountLabel
          defaultSupplierAccountLabel: $defaultSupplierAccountLabel
          defaultCollaboratorAccountLabel: $defaultCollaboratorAccountLabel
          siret: $siret
          siren: $siren
          codeAPE: $codeAPE
          numeroTVA: $numeroTVA
          villeRCS: $villeRCS
          capitalSocial: $capitalSocial
          telFixe: $telFixe
          telMobile: $telMobile
          addresses: { connect: [{ id: $addressId }] }
          invoiceQuotationCompteurMode: $invoiceQuotationCompteurMode
          invoiceStartIndex: $invoiceStartIndex
          quotationStartIndex: $quotationStartIndex
          formatNumeroPiece: $formatNumeroPiece
          relanceAvantPaiement: $relanceAvantPaiement
          relanceAvantFormatTxt: $relanceAvantFormatTxt
          relanceApresPaiement: $relanceApresPaiement
          relanceApresFormatTxt: $relanceApresFormatTxt
        }
      ) {
        # isTaxActive
        id
        aliasMailNetwips
        name
        currency {
          id
        }
        addresses {
          id
          address
          # zipCode
          city
          country {
            id
            label
          }
        }
        # isTaxActive
        formeJuridique
        homepage
        planComptableCharCount
        defaultClientAccountLabel
        defaultSupplierAccountLabel
        defaultCollaboratorAccountLabel
        siret
        siren
        codeAPE
        numeroTVA
        villeRCS
        capitalSocial
        telFixe
        telMobile
      }
      tax1: updateCompany(
        where: { id: $companyId }
        data: { tax1: { connect: { id: $tax1Id } } }
      ) @include(if: $connectTax1) {
        id
        tax1 {
          id
        }
      }
      tax1Disconnected: updateCompany(
        where: { id: $companyId }
        data: { tax1: { disconnect: $disconnectTax1 } }
      ) @include(if: $disconnectTax1) {
        id
        tax1 {
          id
        }
      }
      tax2: updateCompany(
        where: { id: $companyId }
        data: { tax2: { connect: { id: $tax2Id } } }
      ) @include(if: $connectTax2) {
        id
        tax2 {
          id
        }
      }
      tax2Disconnected: updateCompany(
        where: { id: $companyId }
        data: { tax2: { disconnect: $disconnectTax2 } }
      ) @include(if: $disconnectTax2) {
        id
        tax2 {
          id
        }
      }
    }
  `;

  static updateCompanyForDocumentSettingsPage = gql`
    mutation updateCompany(
      $companyId: ID!
      $footer: String!
      $documents: DocumentUpdateManyWithoutCompanyInput,
      $formatPDF: FormatPDFEnum,
      $firmColor: String
    ) {
      updateCompany(
        where: { id: $companyId }
        data: {
          footer: $footer,
          documents: $documents,
          formatPDF: $formatPDF,
          firmColor: $firmColor
        }
      ) {
        id
        footer
        documents {
          id
          conditionsDeVente
          pdfCgvLabel
          pdfCgvPath
          pdfCgvKey
          pdfCgvBucket
          subjectQuotation
          bodyQuotation
          subjectInvoice
          bodyInvoice
          subjectRelance
          bodyRelance
          language {
            id
          }
        }
        versionPDF
        formatPDF
        firmColor
      }
    }
  `;

  static getCompanyDefaultTextQuery = gql`
    query getCompanyDefaultText($companyId: ID!) {
      getCompanyDefaultText(companyId: $companyId) {
        footer
        documents {
          subjectQuotation
          bodyQuotation
          subjectInvoice
          bodyInvoice
          subjectRelance
          bodyRelance
          language {
            id
          }
        }
      }
    }
  `;

  static getOnlyCompanyConditionsDeVenteQuery = gql`
    query getOnlyCompanyConditionsDeVenteQuery(
      $companyId: ID!
      $languageId: ID!
    ) {
      company(where: { id: $companyId }) {
        id
        documents(where: { language: { id: $languageId } }) {
          conditionsDeVente
          language {
            id
          }
        }
      }
    }
  `;

  static createEmptyAddress = gql`
    mutation createAddress($companyId: ID!) {
      createAddress(data: { company: { connect: { id: $companyId } } }) {
        id
      }
    }
  `;

  static createAddress = gql`
    mutation createAddress(
      $companyId: ID!
      $address: String
      # $countryId: ID
      $tiersId: ID
    ) {
      createAddress(
        data: {
          address: $address
          company: { connect: { id: $companyId } }
          # country: { connect: { id: $countryId } }
          label: $address
          tiers: { connect: { id: $tiersId } }
        }
      ) {
        id
        label
        address
        country {
          id
        }
      }
    }
  `;

  /*    static createTax = gql`
    mutation createTax($label: String, $valuePourcent: Float, $companyId: ID) {
      createTax(
        data:{
          label: $label
          valuePourcent: $valuePourcent
          company: {connect: { id: $companyId }}
        }
      ) {
        id
        label
        valuePourcent
        company {
          id
        }

      }
    }
  `;
*/

  static updateAddress = gql`
    mutation updateAddress(
      $addressId: ID
      $address: String
      $tiersId: ID
      $companyId: ID
    ) {
      updateAddress(
        where: { id: $addressId }
        data: {
          address: $address
          label: $address
          company: { connect: { id: $companyId } }
          tiers: { connect: { id: $tiersId } }
        }
      ) {
        id
        label
        address
        country {
          id
        }
      }
    }
  `;

  static connectAddress = gql`
    mutation connectAddress(
      $addressId: ID
      $countryId: ID
      $connectCountry: Boolean!
    ) {
      updateAddress(
        where: { id: $addressId }
        data: { country: { connect: { id: $countryId } } }
      ) @include(if: $connectCountry) {
        id
        country {
          id
        }
      }
    }
  `;

  static GET_ALL_CLIENTS = gql`
    query GetAllClients(
      $companyId: ID!
      $filter: TiersWhereInput!
      $nullValue: ID
    ) {
      _tiersesMeta(
        where: {
          AND: [
            $filter
            { company: { id: $companyId } }
            { client: { id_not: $nullValue } }
          ]
        }
      ) {
        count
      }

      company(where: { id: $companyId }) {
        id
        tierses(
          where: {
            AND: [
              $filter
              { company: { id: $companyId } }
              { client: { id_not: $nullValue } }
            ]
          }
          orderBy: name_ASC
        ) {
          name
          id
        }
      }
    }
  `;

  static GET_CLIENT = gql`
    query getClient($id: ID) {
      tiers(where: { id: $id }) {
        id
        name
        website
        group
        addresses {
          id
          address
          country {
            id
            label
          }
        }
        iban
        swift
        currency {
          id
        }
        company {
          id
        }
        xtraData
        client {
          id
          defaultTermNetsFinDeMois
          defaultTermDelaisPaiement
          siret
          codeAPE
          numeroTVA
          taxIdemCompany
          defaultTax1 {
            id
            valuePourcent
            label
          }
          defaultTax2 {
            id
            valuePourcent
            label
          }
          relanceAuto
          language {
            id
            code
          }
          dateLanguage {
            id
            code
          }
          contacts {
            id
            name
            email
            telFixe
            telMobile
            job
          }
          collaboratorRespCom {
            id
            role
            telFixe
            telMobile
            tiers {
              id
              name
              firstname
              lastname
              email                
              collaborator {
                id
              }
            }
          }
          xtraData
        }
      }
    }
  `;

  static GET_ALL_PROJECTS = gql`
    query getAllProjects($companyId: ID!) {
      company(where: { id: $companyId }) {
        id
        projects(orderBy: name_ASC) {
          id
          name
          active
        }
      }
    }
  `;

  static GET_ACTIVE_PROJECTS = gql`
    query getAllProjects($companyId: ID!) {
      company(where: { id: $companyId }) {
        id
        projects(where: { active: true }, orderBy: name_ASC) {
          id
          name
          active
        }
      }
    }
  `;

  static getTierses = gql`
    query getTierses(
      $companyId: ID!
      $showSuppliers: Boolean = false
      $showClients: Boolean = false
      $showCollaborators: Boolean = false
      $showComptables: Boolean = false
      $nullValue: ID
    ) {
      suppliers: tierses(
        orderBy: name_ASC
        where: {
          AND: [
            { company: { id: $companyId } }
            { supplier: { id_not: $nullValue } }
          ]
        }
      ) @include(if: $showSuppliers) {
        ...tiersInfo
        supplier {
          id
          contacts {
            id
            name
            email
          }
        }
      }
      clients: tierses(
        orderBy: name_ASC
        where: {
          AND: [
            { company: { id: $companyId } }
            { client: { id_not: $nullValue } }
          ]
        }
      ) @include(if: $showClients) {
        ...tiersInfo
        client {
          id
          defaultTermNetsFinDeMois
          defaultTermDelaisPaiement
          contacts {
            id
            name
            email
          }
          defaultTax1 {
            id
            valuePourcent
            label
          }
          defaultTax2 {
            id
            valuePourcent
            label
          }
          language {
            id
            code
          }
          collaboratorRespCom {
            id
            role
            telFixe
            telMobile
            tiers {
              id
              name
              firstname
              lastname
              email                
            }
          }
        }
      }

      collaborators: tierses(
        orderBy: name_ASC
        where: {
          AND: [
            { company: { id: $companyId } }
            { collaborator: { id_not: $nullValue } }
            { collaborator: { role_not: COMPTABLE } }
          ]
        }
      ) @include(if: $showCollaborators) {
        ...tiersInfo
        collaborator {
          id
        }
      }

      comptables: tierses(
        orderBy: name_ASC
        where: {
          AND: [
            { company: { id: $companyId } }
            { collaborator: { id_not: $nullValue } }
            { collaborator: { role: COMPTABLE } }
          ]
        }
      ) @include(if: $showComptables) {
        ...tiersInfo
      }
    }

    fragment tiersInfo on Tiers {
      id
      name
      email
      addresses {
        id
        address
        country {
          id
          label
        }
      }
      defaultTiersSettings {
        id
        indexLine
        defaultCategory {
          id
        }
      }
      currency {
        id
      }
    }
  `;

  static getAllSuppliersForSupplierList = gql`
    query GetAllSuppliers(
      $companyId: ID!
      $filter: TiersWhereInput!
      $skip: Int
      $first: Int
      $nullValue: ID
    ) {
      _tiersesMeta(
        where: {
          AND: [
            $filter
            { company: { id: $companyId } }
            { supplier: { id_not: $nullValue } }
          ]
        }
      ) {
        count
      }

      company(where: { id: $companyId }) {
        id
        tierses(where: $filter, orderBy: name_ASC, skip: $skip, first: $first) {
          ...tiersInfo
        }
      }
    }
  `;

  static addEvent = gql`
    mutation addEvent(
      $companyId: ID!
      $invoiceId: ID
      $quotationId: ID
      $expenseId: ID
      $bankTransactionId: ID
      $eventType: EventTypeEnum
    ) {
      addEvent(
        companyId: $companyId
        invoiceId: $invoiceId
        quotationId: $quotationId
        expenseId: $expenseId
        bankTransactionId: $bankTransactionId
        eventType: $eventType
      ) {
        id
      }
    }
  `;

  static GetBiConnexion = gql`
    query GetBiConnexion($companyId: ID!) {
      company(where: { id: $companyId }) {
        id
        biConnexion {
          id
          accessToken
          connexionId

          userId
          company {
            id
          }
        }
      }
    }
  `;

  // static GET_ALL_BANK_ACCOUNTS = gql`
  //   query GetAllBankAccounts($companyId: ID!) {
  //     company(where: { id: $companyId }) {
  //       id
  //       biConnexion {
  //         id
  //         accessToken
  //         connexionId

  //         userId
  //         company {
  //           id
  //         }
  //       }
  //       providerAccounts {
  //         id
  //         accountId
  //         bic
  //         active
  //         currency {
  //           id
  //           code
  //         }
  //         error
  //         dateLastUpdate
  //         errorMessage
  //         iban
  //         name
  //         number
  //         provider
  //         solde
  //         syncAccount
  //         typeBankAccount
  //       }
  //       bankAccounts(where: { active: true }) {
  //         id
  //         solde
  //         currency {
  //           id
  //         }
  //         company {
  //           id
  //         }
  //         dateCloture
  //         active
  //         syncAccount
  //         name
  //         originalName
  //         providerAccount {
  //           id
  //           accountId
  //           bic
  //           active
  //           currency {
  //             id
  //             code
  //           }
  //           error
  //           dateLastUpdate
  //           errorMessage
  //           iban
  //           name
  //           number
  //           provider
  //           solde
  //           syncAccount
  //           typeBankAccount
  //           providerTransactions(first: 1, orderBy: date_DESC) {
  //             id
  //             date
  //           }
  //         }
  //       }
  //     }
  //   }
  // `;

  static GET_ALL_BANK_ACCOUNTS = gql`
    query companyAllBankAccounts($companyId: ID!) {
      companyAllBankAccounts(id: $companyId) {
        id
        biConnexion {
          id
          accessToken
          connexionId
          userId
          company {
            id
          }
        }
        providerAccounts {
          id
          accountId
          bic
          active
          currency {
            id
            code
          }
          error
          dateLastUpdate
          errorMessage
          iban
          name
          number
          provider
          solde
          syncAccount
          importedAccount
          typeBankAccount
        }
        bankAccounts(where: { active: true }) {
          id
          solde
          countToValidate
          countToQualify
          currency {
            id
          }
          company {
            id
          }
          dateCloture
          active
          syncAccount
          importedAccount
          name
          originalName
          bankTransactions(first: 1, orderBy: date_DESC) {
            id
            date
          }
          providerAccount {
            id
            accountId
            bic
            active
            currency {
              id
              code
            }
            error
            dateLastUpdate
            errorMessage
            iban
            name
            number
            provider
            solde
            syncAccount
            importedAccount
            typeBankAccount
            providerTransactions(first: 1, orderBy: date_DESC) {
              id
              date
            }
          }
        }
      }
    }
  `;

  static GET_ALL_BANK_ACCOUNTS_FOR_EXPORT = gql`
    query GetAllBankAccountsForExport(
      $companyId: ID!
      $dateDu: DateTime
      $dateAu: DateTime      
    ){
      company(where: { id: $companyId }) {
        id
        bankAccounts(
          where: {
            OR :[
              {active: true},
              {reglementAccount: true}
            ]
          }
        ) {
          id
          name
          codeJournal
          reglementAccount
          providerAccount {
            id
          }
          bankTransactions(
            where: {
              status_in: [AQUALIFIER],
              isDeleted: false,
              date_gte: $dateDu,
              date_lte: $dateAu,
              amount_not: null
            }
            first: 1
          ) {
            id
          }
        }
        exports (
          where: {
            periodeDebut_lte: $dateAu
            periodeFin_gte: $dateDu
          }
        ){
          id 
          periodeDebut
          periodeFin
        }
      }
    }
  `;

  static GET_ALL_BANK_ACCOUNTS_FOR_CODE_JOURNAL = gql`
    query GetAllBankAccounts($companyId: ID!) {
      company(where: { id: $companyId }) {
        id
        bankAccounts(
          where: {
            OR :[
              {active: true},
              {reglementAccount: true}
            ]
          }) {
          id
          name
          codeJournal
          reglementAccount
          providerAccount {
            id
          }
          bankTransactions(
            where: { status_in: [AQUALIFIER], isDeleted: false, amount_not: null }
            first: 1
          ) {
            id
          }
        }
      }
    }
  `;

  static GET_BANK_ACCOUNT_PENDING_TRANSACTION_COUNT = gql`
    query transactionsCount($bankAccountId: ID!) {
      _bankTransactionsMeta(
        where: {
          bankAccount: { id: $bankAccountId }
          status: AQUALIFIER
          isDeleted: false
          amount_not: null
        }
      ) {
        count
      }
    }
  `;

  static GET_BANK_ACCOUNT_AUTOQUALIF_TRANSACTION_COUNT = gql`
    query transactionsCount($bankAccountId: ID!) {
      _bankTransactionsMeta(
        where: {
          bankAccount: { id: $bankAccountId }
          status: QUALIFIE_AUTO
          isDeleted: false
          amount_not: null
        }
      ) {
        count
      }
    }
  `;

  static GET_BANK_ACCOUNT_WITHOUT_EXPENSEINVOICE_TRANSACTION_COUNT = gql`
    query transactionsCount($bankAccountId: ID!) {
      _bankTransactionsMeta(
        where: {
          bankAccount: { id: $bankAccountId }
          isDeleted: false
          amount_not: null
          ecritureLines_some: {
            AND: [
              {
                labelLettrage: "",
                OR:[
                  {advancePayment: false},
                  {advancePayment: null}
                ]                
              },
              {
                category: {
                  categoryFamily: {
                    OR: [
                      {supplierCategoryForEcriture: true}
                      {clientCategoryForEcriture: true}
                      {collaboratorCategoryForEcriture: true}
                    ]
                  }
                }
              }
            ]
          }
        }
      ) {
        count
      }
    }
  `;

  static GET_BANK_ACCOUNT = gql`
    query GetBankAccount($id: ID!) {
      bankAccount(where: { id: $id }) {
        id
        name
        dateCloture
        typeBankAccount
        company {
          id
          biConnexion {
            id
            userId
            connexionId
          }
        }
        currency {
          id
        }
        iban
        alertMaxMontant
        alertMaxSolde
        alertMinMontant
        alertMinSolde
        codeJournal
        active
        syncAccount
        importedAccount
        providerAccount {
          id
          provider
          accountId
          connectionId
          bic
          active
          currency {
            id
            code
          }
          error
          dateLastUpdate
          errorMessage
          iban
          name
          number
          provider
          solde
          syncAccount
          importedAccount
          typeBankAccount
        }
      }
    }
  `;

  static UPDATE_BANK_ACCOUNT_MUTATION = gql`
    mutation UpdateBankAccount(
      $id: ID!
      $alertMaxMontant: Float
      $alertMaxSolde: Float
      $alertMinMontant: Float
      $alertMinSolde: Float
      $iban: String
      $name: String
      $syncAccount: Boolean
      $typeBankAccount: String
      $codeJournal: String
      $currencyId: ID
    ) {
      updateBankAccount(
        where: { id: $id }
        data: {
          alertMaxMontant: $alertMaxMontant
          alertMaxSolde: $alertMaxSolde
          alertMinMontant: $alertMinMontant
          alertMinSolde: $alertMinSolde
          iban: $iban
          name: $name
          syncAccount: $syncAccount
          typeBankAccount: $typeBankAccount
          codeJournal: $codeJournal
          currency: { connect: { id: $currencyId } }
        }
      ) {
        id
        name
        currency {
          id
        }
      }
    }
  `;

  static UPDATE_BANK_ACCOUNT_CODEJOURNAL_MUTATION = gql`
    mutation UpdateBankAccount($id: ID!, $codeJournal: String) {
      updateBankAccount(
        where: { id: $id }
        data: { codeJournal: $codeJournal }
      ) {
        id
      }
    }
  `;

  static GET_BANK_TRANSACTIONS_COUNT = gql`
    query transactionsCount($bankAccountId: ID!) {
      allCount: _bankTransactionsMeta(
        where: { bankAccount: { id: $bankAccountId }, isDeleted: false, amount_not: null }
      ) {
        count
      }
      toQualifyCount: _bankTransactionsMeta(
        where: {
          bankAccount: { id: $bankAccountId }
          status: AQUALIFIER
          isDeleted: false
          amount_not: null
        }
      ) {
        count
      }
    }
  `;

  // static GET_ALL_BANK_TRANSACTIONS = gql`
  //   query GetAllBankTransactions(
  //     $bankAccountId: ID!
  //     $filter: BankTransactionWhereInput!
  //     $skip: Int
  //     $first: Int
  //   ) {
  //     _bankTransactionsMeta(
  //       where: { AND: [$filter, { bankAccount: { id: $bankAccountId } }] }
  //     ) {
  //       count
  //     }
  //     bankAccount(where: { id: $bankAccountId }) {
  //       id
  //       currency {
  //         id
  //       }
  //       dateLastUpdate
  //       dateCloture
  //       bankTransactions(
  //         skip: $skip
  //         first: $first
  //         where: $filter
  //         orderBy: date_DESC
  //       ) {
  //         id
  //         date
  //         amount
  //         companyCurrencyAmount
  //         libelleCourt
  //         libelleLong
  //         modePaiement
  //         sensTransaction
  //         status
  //         isDeleted
  //         bankAccount {
  //           id
  //           name
  //         }
  //         providerTransaction {
  //           id
  //         }
  //         attachment {
  //           id
  //         }
  //         ecritureLines {
  //           id
  //           amount
  //           tiers {
  //             id
  //             name
  //             currency {
  //               id
  //             }
  //             client {
  //               id
  //               defaultTermNetsFinDeMois
  //               defaultTermDelaisPaiement
  //             }
  //           }
  //           labelLettrage
  //           advancePayment
  //           category {
  //             id
  //             ids
  //             name
  //             categoryFamily {
  //               id
  //               ids
  //               clientCategoryForEcriture
  //               supplierCategoryForEcriture
  //               collaboratorCategoryForEcriture
  //             }
  //           }
  //         }
  //         bankTransactionLines(orderBy: numLine_ASC) {
  //           id
  //           tiers {
  //             id
  //             name
  //           }
  //           advancePayment
  //           category {
  //             id
  //             ids
  //             name
  //             categoryFamily {
  //               id
  //               ids
  //               clientCategoryForEcriture
  //               supplierCategoryForEcriture
  //               collaboratorCategoryForEcriture
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // `;

  static GET_ALL_BANK_TRANSACTIONS = gql`
    query GetAllBankTransactions(
      $bankAccountId: ID!
      $filter: BankTransactionWhereInput!
      $skip: Int
      $first: Int
      $companyId: ID!
    ) {
      _bankTransactionsMeta(
        where: {
          AND: [
            $filter,
            {
              bankAccount: {
                id: $bankAccountId
              },
              amount_not: null
            }
          ]}
      ) {
        count
      }
      getAllBankTransactions (
          companyId: $companyId
          skip: $skip
          first: $first
          where: { AND: [
            $filter,
            {
              bankAccount: {
                id: $bankAccountId
              },
              amount_not: null
            }
          ]}
          orderBy: date_DESC
        ) {
          id
          date
          amount
          companyCurrencyAmount
          libelleCourt
          libelleLong
          modePaiement
          sensTransaction
          status
          isDeleted
          bankAccount {
            id
            name
            syncAccount
            importedAccount
            currency {
              id
            }
            dateLastUpdate
            dateCloture
          }
          providerTransaction {
            id
          }
          attachment {
            id
          }
          ecritureLines {
            id
            amount
            tiers {
              id
              name
              currency {
                id
              }
              client {
                id
                defaultTermNetsFinDeMois
                defaultTermDelaisPaiement
              }
            }
            labelLettrage
            advancePayment
            category {
              id
              ids
              name
              categoryFamily {
                id
                ids
                clientCategoryForEcriture
                supplierCategoryForEcriture
                collaboratorCategoryForEcriture
              }
            }
          }
          bankTransactionLines(orderBy: numLine_ASC) {
            id
            tiers {
              id
              name
            }
            advancePayment
            category {
              id
              ids
              name
              categoryFamily {
                id
                ids
                clientCategoryForEcriture
                supplierCategoryForEcriture
                collaboratorCategoryForEcriture
              }
            }
          }
        }
      }
  `;

  static GET_BANK_TRANSACTION = gql`
    query GetBankTransaction($id: ID!, $companyId: ID!) {
      bankTransaction(id: $id, companyId: $companyId) {
        id
        company {
          id
        }
        date
        amount
        companyCurrencyAmount
        status
        isDeleted
        modePaiement
        libelleCourt
        libelleLong
        sensTransaction
        attachment {
          id
          bucket
          key
          label
          path
        }
        ecritureLines {
          id
          labelLettrage
          tiers {
            id
            name
          }
          amount
          advancePayment
        }
        bankAccount {
          id
          name
          currency {
            id
          }
        }
        providerTransaction {
          id
        }
        bankTransactionLines(orderBy: numLine_ASC) {
          id
          amount
          advancePayment
          companyCurrencyAmount
          numLine
          valueTax
          taxPieces {
            id
            taux
            label
            baseHT
            amount
            tax {
              id
              label
            }
          }

          project {
            id
          }

          tiersClient {
            id
          }

          category {
            id
            ids
            name
            categoryFamily {
              id
              ids
              name
              reportRentability
            }
          }
          tiers {
            id
            currency {
              id
            }
            client {
              id
              defaultTermNetsFinDeMois
              defaultTermDelaisPaiement
            }
            collaborator {
              id
            }
            supplier {
              id
            }
          }
        }
      }
    }
  `;

  static UPDATE_BANK_TRANSACTION_MUTATION = gql`
    mutation UpdateBankTransaction(
      $id: ID!
      $status: BankTransactionStatus
      $attachmentId: ID
      $connectAttachment: Boolean!
      $date: DateTime!
      $fullUpdate: Boolean
    ) {
      updateBankTransaction(
        where: { id: $id }
        data: { status: $status, date: $date }
        fullUpdate: $fullUpdate
      ) {
        id
        date
        amount
        companyCurrencyAmount
        status
        modePaiement
        libelleCourt
        libelleLong
        bankAccount {
          id
          name
          currency {
            id
          }
        }
        attachment {
          id
        }
        bankTransactionLines(orderBy: numLine_ASC) {
          id
          amount
          companyCurrencyAmount
          valueTax
          numLine
          category {
            id
          }
          taxPieces {
            id
            taux
            tax {
              id
            }
          }

          tiers {
            id
            client {
              id
            }
            collaborator {
              id
            }
            supplier {
              id
            }
          }
        }
      }

      updateAttachment(
        where: { id: $attachmentId }
        data: { bankTransaction: { connect: { id: $id } } }
      ) @include(if: $connectAttachment) {
        id
        bankTransaction {
          id
        }
      }
    }
  `;

  static CONFIRM_BANK_TRANSACTION_MUTATION = gql`
    mutation ConfirmBankTransaction($id: ID!) {
      confirmBankTransaction(where: { id: $id }) {
        id
      }
    }
  `;

  static VALIDATE_ALL_BANK_TRANSACTIONS_MUTATION = gql`
    mutation ValidateAllBankTransactions($id: ID!) {
      validateAllBankTransactions(where: { id: $id }) {
        id
      }
    }
  `;

  // WILL UPDATE isDeleted...
  static DELETE_BANK_TRANSACTION_MUTATION = gql`
    mutation DeleteBankTransaction($id: ID!) {
      deleteBankTransaction(where: { id: $id }) {
        id
      }
    }
  `;

  static REQUALIFY_BANK_TRANSACTION_MUTATION = gql`
    mutation ReQualifyBankTransaction($id: ID!) {
      reQualifyBankTransaction(where: { id: $id }) {
        id
      }
    }
  `;

  static CREATE_BANK_TRANSACTION_LINE_MUTATION = gql`
    mutation CreateBankTransactionLine(
      $bankTransactionId: ID!
      $amount: Float
      $companyCurrencyAmount: Float
      $valueTax: Float
      $tiersId: ID
      $categoryId: ID
      $numLine: Int
      $taxPieces: TaxPieceCreateManyWithoutBankTransactionLineInput
      $advancePayment: Boolean
    ) {
      createBankTransactionLine(
        data: {
          bankTransaction: { connect: { id: $bankTransactionId } }
          category: { connect: { id: $categoryId } }
          tiers: { connect: { id: $tiersId } }
          amount: $amount
          companyCurrencyAmount: $companyCurrencyAmount
          valueTax: $valueTax
          numLine: $numLine
          taxPieces: $taxPieces
          advancePayment: $advancePayment
        }
      ) {
        id
      }
    }
  `;

  static CREATE_BANK_TRANSACTION_LINE_WITHOUT_TIERSID_MUTATION = gql`
    mutation CreateBankTransactionLineWithoutTiersId(
      $bankTransactionId: ID!
      $projectId: ID
      $tiersClientId: ID
      $amount: Float
      $companyCurrencyAmount: Float
      $valueTax: Float
      $categoryId: ID
      $numLine: Int
      $taxPieces: TaxPieceCreateManyWithoutBankTransactionLineInput
      $advancePayment: Boolean
    ) {
      createBankTransactionLine(
        data: {
          bankTransaction: { connect: { id: $bankTransactionId } }
          category: { connect: { id: $categoryId } }
          project: { connect: { id: $projectId } }
          tiersClient: { connect: { id: $tiersClientId } }
          amount: $amount
          companyCurrencyAmount: $companyCurrencyAmount
          valueTax: $valueTax
          numLine: $numLine
          taxPieces: $taxPieces
          advancePayment: $advancePayment
        }
      ) {
        id
      }
    }
  `;
  static UPDATE_BANK_TRANSACTION_LINE_MUTATION = gql`
    mutation UpdateBankTransactionLine(
      $id: ID!
      $bankTransactionId: ID!
      $amount: Float
      $companyCurrencyAmount: Float
      $tiersId: ID
      $categoryId: ID
      $numLine: Int
      $taxPieces: TaxPieceUpdateManyWithoutBankTransactionLineInput
      $advancePayment: Boolean
    ) {
      updateBankTransactionLine(
        where: { id: $id }
        data: {
          bankTransaction: { connect: { id: $bankTransactionId } }
          category: { connect: { id: $categoryId } }
          tiers: { connect: { id: $tiersId } }
          amount: $amount
          companyCurrencyAmount: $companyCurrencyAmount
          numLine: $numLine
          taxPieces: $taxPieces
          advancePayment: $advancePayment
        }
      ) {
        id
        category {
          id
        }
        amount
        tiers {
          id
        }
        project {
          id
        }
        numLine
        taxPieces {
          id
        }
      }
    }
  `;
  static DELETE_BANK_TRANSACTION_LINE_MUTATION = gql`
    mutation DeleteBankTransactionLine($id: ID!) {
      deleteBankTransactionLine(where: { id: $id }) {
        id
      }
    }
  `;

  static getCompanyCurrency = gql`
    query getCompanyCurrency($companyId: ID) {
      company(where: { id: $companyId }) {
        id
        currency {
          id
        }
      }
    }
  `;


  // static GET_ALL_LANGUAGES = gql`
  //   query GetAllLanguages {
  //     languages {
  //       id
  //       code
  //       label
  //     }
  //   }
  // `;

  static getParamsForOdooExport = gql`
    query getParamsForOdooExport($companyId: ID) {
      companyParamsForOdooExport(where: { id: $companyId }) { 
        id
        invitations (where: {email: "IMPORT TO ODOO PARAMS"}) {
          id
          name
        }
      }
    }
  `;

  // static updateOdooImportSettings = gql`
  //   mutation ImportToOdoo(
  //     $companyId: ID!
  //     $exportId: ID
  //     $locale: String
  //     $host: String,
  //     $dbname: String,
  //     $companyname: String,
  //     $login: String,
  //     $password: String
  //   ) {
  //     importToOdoo(
  //       companyId: $companyId
  //       exportId: $exportId
  //       locale: $locale
  //       host: $host
  //       dbname: $dbname
  //       companyname: $companyname
  //       login: $login
  //       password: $password
  //     ) {
  //       result
  //     }
  //   }
  // `;


  static IMPORT_TO_ODOO_MUTATION = gql`
    mutation importToOdoo(
      $companyId: ID!
      $fileName: String
      $format: String
      $fileKey: String      
      $fileUrl: String
    ) {
      importToOdoo(
        companyId: $companyId
        fileName: $fileName
        format: $format
        fileKey: $fileKey
        fileUrl: $fileUrl
      ) {
        result
      }
    }
  `;

  static DELETE_IMPORT_TO_ODOO_FILE_MUTATION = gql`
    mutation deleteimportToOdoo(
      $companyId: ID!
      $odooImportId: ID
    ) {
      deleteimportToOdoo(
        companyId: $companyId
        odooImportId: $odooImportId
      ) {
        result
      }
    }
  `;

  static EXPORT_TO_ODOO_MUTATION = gql`
    mutation exportToOdoo(
      $companyId: ID!
      $exportId: ID
      $locale: String
      $host: String,
      $dbname: String,
      $companyname: String,
      $login: String,
      $password: String,
      $createOdooPartners: String,
      $createOdooClients: String,
      $createOdooSuppliers: String,
    ) {
      exportToOdoo(
        companyId: $companyId
        exportId: $exportId
        locale: $locale
        host: $host
        dbname: $dbname
        companyname: $companyname
        login: $login
        password: $password
        createOdooPartners: $createOdooPartners
        createOdooClients: $createOdooClients
        createOdooSuppliers: $createOdooSuppliers
      ) {
        result
      }
    }
  `;

  static CONNECT_SUPPLIER_MUTATION = gql`
    mutation ConnectSupplier(
      $id: ID!
      $tax1Id: ID
      $tax2Id: ID
      $connectTax1: Boolean!
      $connectTax2: Boolean!
      $disconnectTax1: Boolean!
      $disconnectTax2: Boolean!      
    ) {
      defaultTax1: updateSupplier(
        where: { id: $id }
        data: { defaultTax1: { connect: { id: $tax1Id } } }
      ) @include(if: $connectTax1) {
        id
        defaultTax1 {
          id
        }
      }
      defaultTax1Disconnected: updateSupplier(
        where: { id: $id }
        data: { defaultTax1: { disconnect: $disconnectTax1 } }
      ) @include(if: $disconnectTax1) {
        id
        defaultTax1 {
          id
        }
      }
      defaultTax2: updateSupplier(
        where: { id: $id }
        data: { defaultTax2: { connect: { id: $tax2Id } } }
      ) @include(if: $connectTax2) {
        id
        defaultTax2 {
          id
        }
      }
      defaultTax2Disconnected: updateSupplier(
        where: { id: $id }
        data: { defaultTax2: { disconnect: $disconnectTax2 } }
      ) @include(if: $disconnectTax2) {
        id
        defaultTax2 {
          id
        }
      }
    }
  `;

  static UPDATE_SUPPLIER_MUTATION = gql`
    mutation UpdateSupplier(
      $id: ID!
      $name: String!
      $defaultTermNetsFinDeMois: TermNetsFinDeMoisEnum
      $defaultTermDelaisPaiement: TermDelaisDePaiementEnum
      $siret: String
      $codeAPE: String
      $numeroTVA: String
      $website: String #      $address: String
      $iban: String
      $swift: String #     $country: ID
      $supplierId: ID
      $taxIdemCompany: Boolean
      $currencyId: ID
      $group: String
      $xtraData: String
    ) {
      #      $addressId: ID
      updateSupplier(
        where: { id: $supplierId }
        data: {
          defaultTermNetsFinDeMois: $defaultTermNetsFinDeMois
          defaultTermDelaisPaiement: $defaultTermDelaisPaiement
          siret: $siret
          taxIdemCompany: $taxIdemCompany
          codeAPE: $codeAPE
          numeroTVA: $numeroTVA
        }
      ) {
        id
        defaultTermNetsFinDeMois
        defaultTermDelaisPaiement
        taxIdemCompany
        siret
        codeAPE
        numeroTVA
      }

      updateTiers(
        where: { id: $id }
        data: {
          name: $name
          website: $website
          iban: $iban
          swift: $swift
          currency: { connect: { id: $currencyId } }
          group: $group
          xtraData: $xtraData
        }
      ) {
        id
        group
        name
        website
        addresses {
          id
          address
          country {
            id
          }
        }
        iban
        swift
        currency {
          id
        }
        company {
          id
        }
        xtraData
        supplier {
          id
          defaultTermNetsFinDeMois
          defaultTermDelaisPaiement
          siret
          codeAPE
          numeroTVA
          contacts {
            id
            name
            email
            telFixe
            telMobile
            job
          }
          xtraData
        }
      }
    }
  `;

  static UPDATE_ODOO_SUPPLIER_MUTATION = gql`
    mutation UpdateSupplier(
      $id: ID!
      $name: String!
      $supplierId: ID
      $taxIdemCompany: Boolean
      $currencyId: ID
      $xtraData: String
    ) {
      #      $addressId: ID
      updateSupplier(
        where: { id: $supplierId }
        data: {
          taxIdemCompany: $taxIdemCompany
        }
      ) {
        id
        taxIdemCompany
      }

      updateTiers(
        where: { id: $id }
        data: {
          name: $name
          currency: { connect: { id: $currencyId } }
          xtraData: $xtraData
        }
      ) {
        id
        currency {
          id
        }
        company {
          id
        }
        xtraData
        supplier {
          id
          xtraData
        }
      }
    }
  `;

  static CREATE_SUPPLIER_MUTATION = gql`
    mutation CreateSupplier(
      $companyId: ID!
      $name: String!
      $contacts: [ContactCreateWithoutSupplierInput!]
      $defaultTermNetsFinDeMois: TermNetsFinDeMoisEnum
      $defaultTermDelaisPaiement: TermDelaisDePaiementEnum
      $siret: String
      $codeAPE: String
      $numeroTVA: String
      $website: String
      $address: String
      $country: ID
      $iban: String
      $swift: String
      $currency: ID
      $group: String
      $taxIdemCompany: Boolean
      $xtraData: String
    ) {
      createTiers(
        data: {
          name: $name
          website: $website
          group: $group
          addresses: {
            create: [
              {
                label: $address
                address: $address
                country: { connect: { id: $country } }
              }
            ]
          }
          iban: $iban
          swift: $swift
          xtraData: $xtraData
          currency: { connect: { id: $currency } }
          company: { connect: { id: $companyId } }
          supplier: {
            create: {
              defaultTermNetsFinDeMois: $defaultTermNetsFinDeMois
              defaultTermDelaisPaiement: $defaultTermDelaisPaiement
              siret: $siret
              codeAPE: $codeAPE
              numeroTVA: $numeroTVA
              taxIdemCompany: $taxIdemCompany
              contacts: { create: $contacts }
              company: { connect: { id: $companyId } }
            }
          }
        }
      ) {
        name
        id
        supplier {
          id
        }
        currency {
          id
        }
      }
    }
  `;

  static CREATE_ODOO_SUPPLIER_MUTATION = gql`
    mutation CreateSupplier(
      $companyId: ID!
      $name: String!
      $currency: ID
      $taxIdemCompany: Boolean
      $xtraData: String
    ) {
      createTiers(
        data: {
          name: $name
          xtraData: $xtraData
          currency: { connect: { id: $currency } }
          company: { connect: { id: $companyId } }
          supplier: {
            create: {
              taxIdemCompany: $taxIdemCompany
              company: { connect: { id: $companyId } }
            }
          }
        }
      ) {
        name
        id
        supplier {
          id
        }
        currency {
          id
        }
      }
    }
  `;

  static GET_SUPPLIER = gql`
    query getSupplier($id: ID) {
      tiers(where: { id: $id }) {
        id
        name
        website
        addresses {
          id
          address
          country {
            id
            __typename
          }
          __typename
        }
        group
        iban
        swift
        currency {
          id
          __typename
        }
        company {
          id
          __typename
        }
        xtraData
        supplier {
          id
          defaultTermNetsFinDeMois
          defaultTermDelaisPaiement
          siret
          codeAPE
          numeroTVA
          taxIdemCompany
          defaultTax1 {
            id
            valuePourcent
            label
          }
          defaultTax2 {
            id
            valuePourcent
            label
          }
          company {
            id
          }
          contacts {
            id
            name
            email
            telFixe
            telMobile
            job
            __typename
          }
          xtraData
          __typename
        }
        __typename
      }
    }
  `;

  static CREATE_SUPPLIER_CONTACT_MUTATION = gql`
    mutation CreateContact(
      $supplierId: ID
      $email: String
      $job: String
      $name: String
      $telFixe: String
      $telMobile: String
      $companyId: ID
    ) {
      createContact(
        data: {
          supplier: { connect: { id: $supplierId } }
          email: $email
          job: $job
          name: $name
          telFixe: $telFixe
          telMobile: $telMobile
          company: { connect: { id: $companyId } }
        }
      ) {
        id
        email
        job
        name
        telFixe
        telMobile
        company {
          id
        }
      }
    }
  `;

  static CREATE_CLIENT_CONTACT_MUTATION = gql`
    mutation CreateContact(
      $clientId: ID
      $email: String
      $job: String
      $name: String
      $telFixe: String
      $telMobile: String
      $companyId: ID
    ) {
      createContact(
        data: {
          client: { connect: { id: $clientId } }
          email: $email
          job: $job
          name: $name
          telFixe: $telFixe
          telMobile: $telMobile
          company: { connect: { id: $companyId } }
        }
      ) {
        id
        email
        job
        name
        telFixe
        telMobile
        company {
          id
        }
      }
    }
  `;
  // static CREATE_CONTACT_MUTATION = gql`
  //   mutation CreateContact(
  //     $supplierId: ID
  //     $clientId: ID
  //     $email: String
  //     $job: String
  //     $name: String
  //     $telFixe: String
  //     $telMobile: String
  //     $companyId: ID
  //   ) {
  //     createContact(
  //       data: {
  //         client: { connect: { id: $clientId } }
  //         supplier: { connect: { id: $supplierId } }
  //         email: $email
  //         job: $job
  //         name: $name
  //         telFixe: $telFixe
  //         telMobile: $telMobile
  //         company: { connect: { id: $companyId } }
  //       }
  //     ) {
  //       id
  //       email
  //       job
  //       name
  //       telFixe
  //       telMobile
  //       company {
  //         id
  //       }
  //     }
  //   }
  // `;
  static UPDATE_CONTACT_MUTATION = gql`
    mutation UpdateContact(
      $id: ID!
      $email: String
      $job: String
      $name: String
      $telFixe: String
      $telMobile: String
      $companyId: ID
    ) {
      updateContact(
        where: { id: $id }
        data: {
          email: $email
          job: $job
          name: $name
          telFixe: $telFixe
          telMobile: $telMobile
          company: { connect: { id: $companyId } }
        }
      ) {
        id
        email
        job
        name
        telFixe
        telMobile
        company {
          id
        }
      }
    }
  `;

  static DELETE_CONTACT_MUTATION = gql`
    mutation DeleteContact($id: ID!) {
      deleteContact(where: { id: $id }) {
        id
      }
    }
  `;

  static getCompanyForAliasEmailEditForm = gql`
    query getCompanyForAliasEmailEditForm($companyId: ID) {
      company(where: { id: $companyId }) {
        id
        name
        aliasMailNetwips
      }
    }
  `;

  static updateCompanyAliasMail = gql`
    mutation UpdateCompanyAliasMail(
      $companyId: ID!
      $aliasMailNetwips: String
    ) {
      updateCompany(
        where: { id: $companyId }
        data: { aliasMailNetwips: $aliasMailNetwips }
      ) {
        id
        aliasMailNetwips
      }
    }
  `;

  static getCompanyProjectsForProjectSettings = gql`
    query GetCompanyProjectsForProjectSettings($companyId: ID!) {
      company(where: { id: $companyId }) {
        id
        projects(orderBy: name_ASC) {
          id
          name
          active
          projectType
          dateFinPrevue
          tiersClient {
            id
            name
          }
          tiersCollaborator {
            id
            name
          }
        }
      }
    }
  `;

  static createProject = gql`
    mutation createProject(
      $companyId: ID
      $name: String!
      $active: Boolean
      $dateFinPrevue: DateTime
      $projectType: String
    ) {
      createProject(
        data: {
          company: { connect: { id: $companyId } }
          name: $name
          active: $active
          dateFinPrevue: $dateFinPrevue
          projectType: $projectType
        }
      ) {
        id
        name
        active
        dateFinPrevue
        projectType
        company {
          id
        }
      }
    }
  `;

  static connectProject = gql`
    mutation connectProject(
      $projectId: ID!
      $connectClient: Boolean!
      $connectCollaborator: Boolean!
      $disconnectClient: Boolean!
      $disconnectCollaborator: Boolean!
      $tiersClientId: ID
      $tiersCollaboratorId: ID
    ) {
      client: updateProject(
        where: { id: $projectId }
        data: { tiersClient: { connect: { id: $tiersClientId } } }
      ) @include(if: $connectClient) {
        id
        tiersClient {
          id
        }
      }
      clientDisco: updateProject(
        where: { id: $projectId }
        data: { tiersClient: { disconnect: true } }
      ) @include(if: $disconnectClient) {
        id
        tiersClient {
          id
        }
      }
      collaborator: updateProject(
        where: { id: $projectId }
        data: { tiersCollaborator: { connect: { id: $tiersCollaboratorId } } }
      ) @include(if: $connectCollaborator) {
        id
        tiersCollaborator {
          id
        }
      }
      collaboratorDisco: updateProject(
        where: { id: $projectId }
        data: { tiersCollaborator: { disconnect: true } }
      ) @include(if: $disconnectCollaborator) {
        id
        tiersCollaborator {
          id
        }
      }
    }
  `;

  static UPDATE_CLIENT_MUTATION = gql`
    mutation UpdateTiersForClient(
      $id: ID!
      $clientId: ID!
      $name: String!
      $defaultTermNetsFinDeMois: TermNetsFinDeMoisEnum
      $defaultTermDelaisPaiement: TermDelaisDePaiementEnum
      $siret: String
      $codeAPE: String
      $numeroTVA: String
      $website: String #$address: String
      #$country: ID
      $iban: String
      $swift: String
      $languageId: ID
      $dateLanguageId: ID
      $relanceAuto: Boolean
      $taxIdemCompany: Boolean
      $currencyId: ID
      $group: String
      $xtraData: String
    ) {
      updateClient(
        where: { id: $clientId }
        data: {
          defaultTermNetsFinDeMois: $defaultTermNetsFinDeMois
          defaultTermDelaisPaiement: $defaultTermDelaisPaiement
          siret: $siret
          taxIdemCompany: $taxIdemCompany
          codeAPE: $codeAPE
          numeroTVA: $numeroTVA          
          language: { connect: { id: $languageId } }
          dateLanguage: { connect: { id: $dateLanguageId } }
          relanceAuto: $relanceAuto
        }
      ) {
        id
        defaultTermNetsFinDeMois
        defaultTermDelaisPaiement
        taxIdemCompany
        siret
        codeAPE
        numeroTVA
        language {
          id
          code
        }
        dateLanguage {
          id
          code
        }
        relanceAuto
      }

      updateTiers(
        where: { id: $id }
        data: {
          name: $name
          website: $website
          iban: $iban
          swift: $swift
          group: $group
          xtraData: $xtraData
          currency: { connect: { id: $currencyId } }
        }
      ) {
        id
        name
        website
        group
        addresses {
          id
          address
          country {
            id
            label
          }
        }
        iban
        swift
        currency {
          id
        }
        company {
          id
        }
        client {
          id
          defaultTermNetsFinDeMois
          defaultTermDelaisPaiement
          siret
          codeAPE
          numeroTVA
          relanceAuto
          language {
            id
            code
          }
          dateLanguage {
            id
            code
          }
          contacts {
            id
            name
            email
            telFixe
            telMobile
            job
          }
        }
      }
    }
  `;


  static UPDATE_ODOO_CLIENT_MUTATION = gql`
    mutation UpdateTiersForClient(
      $id: ID!
      $clientId: ID!
      $name: String!
      $taxIdemCompany: Boolean
      $currencyId: ID
      $xtraData: String
    ) {
      updateClient(
        where: { id: $clientId }
        data: {
          taxIdemCompany: $taxIdemCompany
        }
      ) {
        id
        taxIdemCompany
      }

      updateTiers(
        where: { id: $id }
        data: {
          name: $name
          xtraData: $xtraData
          currency: { connect: { id: $currencyId } }
        }
      ) {
        id
        name
        currency {
          id
        }
        company {
          id
        }
        client {
          id
        }
      }
    }
  `;

  static CONNECT_CLIENT_MUTATION = gql`
    mutation ConnectClient(
      $id: ID!
      $tax1Id: ID
      $tax2Id: ID
      $connectTax1: Boolean!
      $connectTax2: Boolean!
      $disconnectTax1: Boolean!
      $disconnectTax2: Boolean!
      $connectCollaboratorRespComId: Boolean!
      $disconnectCollaboratorRespComId: Boolean!
      $collaboratorRespComId: ID
    ) {
      defaultTax1: updateClient(
        where: { id: $id }
        data: { defaultTax1: { connect: { id: $tax1Id } } }
      ) @include(if: $connectTax1) {
        id
        defaultTax1 {
          id
        }
      }
      defaultTax1Disconnected: updateClient(
        where: { id: $id }
        data: { defaultTax1: { disconnect: $disconnectTax1 } }
      ) @include(if: $disconnectTax1) {
        id
        defaultTax1 {
          id
        }
      }
      defaultTax2: updateClient(
        where: { id: $id }
        data: { defaultTax2: { connect: { id: $tax2Id } } }
      ) @include(if: $connectTax2) {
        id
        defaultTax2 {
          id
        }
      }
      defaultTax2Disconnected: updateClient(
        where: { id: $id }
        data: { defaultTax2: { disconnect: $disconnectTax2 } }
      ) @include(if: $disconnectTax2) {
        id
        defaultTax2 {
          id
        }
      }

      collaboratorRespComConnected: updateClient(
        where: { id: $id }
        data: {
          collaboratorRespCom: { connect: { id: $collaboratorRespComId } }
        }
      ) @include(if: $connectCollaboratorRespComId) {
        id
        collaboratorRespCom {
          id
          tiers {
            id
            name
          }
        }
      }
      collaboratorRespComDisconnected: updateClient(
        where: { id: $id }
        data: {
          collaboratorRespCom: { disconnect: $disconnectCollaboratorRespComId }
        }
      ) @include(if: $disconnectCollaboratorRespComId) {
        id
        collaboratorRespCom {
          id
          tiers {
            id
            name
          }
        }
      }
    }
  `;

  static CONNECT_ODOO_CLIENT_MUTATION = gql`
    mutation ConnectClient(
      $id: ID!
      $tax1Id: ID
      $tax2Id: ID
      $connectTax1: Boolean!
      $connectTax2: Boolean!
      $disconnectTax1: Boolean!
      $disconnectTax2: Boolean!
    ) {
      defaultTax1: updateClient(
        where: { id: $id }
        data: { defaultTax1: { connect: { id: $tax1Id } } }
      ) @include(if: $connectTax1) {
        id
        defaultTax1 {
          id
        }
      }
      defaultTax1Disconnected: updateClient(
        where: { id: $id }
        data: { defaultTax1: { disconnect: $disconnectTax1 } }
      ) @include(if: $disconnectTax1) {
        id
        defaultTax1 {
          id
        }
      }
      defaultTax2: updateClient(
        where: { id: $id }
        data: { defaultTax2: { connect: { id: $tax2Id } } }
      ) @include(if: $connectTax2) {
        id
        defaultTax2 {
          id
        }
      }
      defaultTax2Disconnected: updateClient(
        where: { id: $id }
        data: { defaultTax2: { disconnect: $disconnectTax2 } }
      ) @include(if: $disconnectTax2) {
        id
        defaultTax2 {
          id
        }
      }
    }
  `;

  static CREATE_CLIENT_MUTATION = gql`
    mutation CreateClient(
      $companyId: ID!
      $name: String!
      $contacts: [ContactCreateWithoutClientInput!]
      $defaultTermNetsFinDeMois: TermNetsFinDeMoisEnum
      $defaultTermDelaisPaiement: TermDelaisDePaiementEnum
      $siret: String
      $codeAPE: String
      $numeroTVA: String
      $website: String
      $address: String
      $iban: String
      $swift: String
      $language: ID
      $dateLanguage: ID
      $relanceAuto: Boolean
      $country: ID
      $currency: ID
      $group: String
      $taxIdemCompany: Boolean
      $xtraData: String
    ) {
      createTiers(
        data: {
          name: $name
          website: $website
          addresses: {
            create: [
              {
                label: $address
                address: $address
                country: { connect: { id: $country } }
              }
            ]
          }
          iban: $iban
          group: $group
          swift: $swift
          xtraData: $xtraData
          currency: { connect: { id: $currency } }
          company: { connect: { id: $companyId } }
          client: {
            create: {
              defaultTermNetsFinDeMois: $defaultTermNetsFinDeMois
              defaultTermDelaisPaiement: $defaultTermDelaisPaiement
              siret: $siret
              codeAPE: $codeAPE
              numeroTVA: $numeroTVA
              relanceAuto: $relanceAuto
              taxIdemCompany: $taxIdemCompany
              language: { connect: { id: $language } }
              dateLanguage: { connect: { id: $dateLanguage } }
              contacts: { create: $contacts }
            }
          }
        }
      ) {
        id
        name
        website
        group
        addresses {
          id
          address
          country {
            id
          }
        }
        iban
        swift
        currency {
          id
        }
        company {
          id
        }
        xtraData
        client {
          id
          defaultTermNetsFinDeMois
          defaultTermDelaisPaiement
          siret
          codeAPE
          numeroTVA
          relanceAuto
          language {
            id
            code
          }
          dateLanguage {
            id
            code
          }
          contacts {
            id
            name
            email
            telFixe
            telMobile
            job
          }
        }
      }
    }
  `;

  static CREATE_ODOO_CLIENT_MUTATION = gql`
mutation CreateClient(
  $companyId: ID!
  $name: String!     
  $currency: ID 
  $taxIdemCompany: Boolean
  $xtraData: String
) {
  createTiers(
    data: {
      name: $name      
      xtraData: $xtraData
      currency: { connect: { id: $currency } }
      company: { connect: { id: $companyId } }
      client: {
        create: {          
          taxIdemCompany: $taxIdemCompany     
          company: { connect: { id: $companyId } }    
        }
      }
    }
  ) {
    id
    name   
    currency {
      id
    }
    company {
      id
    }
    xtraData
    client {
      id
    }
  }
}
`;

  static DELETE_TIERS_MUTATION = gql`
    mutation DeleteTiers($id: ID!) {
      deleteTiersAfterCheck(where: { id: $id }) {
        result
      }
    }
  `;

  static CHECK_ONLY_DELETE_TIERS = gql`
    query CheckOnlyDeleteTiers($id: ID!) {
      checkOnlyDeleteTiers(where: { id: $id }) {
        result
      }
    }
  `;

  static GET_ALL_LANGUAGES = gql`
    query GetAllLanguages {
      languages {
        id
        code
        label
      }
    }
  `;

  static GET_COMPANY_DEFAULT_TAXES = gql`
    query getCompanyDefaultTaxes($companyId: ID!) {
      company(where: { id: $companyId }) {
        isTaxActive
        tax1 {
          id
          label
          valuePourcent
        }
        tax2 {
          id
          label
          valuePourcent
        }
      }
    }
  `;

  static GET_ALL_COMPANY_TAXES = gql`
    query getCompanyTaxes($companyId: ID!) {
      company(where: { id: $companyId }) {
        id
        taxes {
          id
          label
          valuePourcent
          active
          mode
          xtraData
        }
        isTaxActive
        tax1 {
          id
          label
        }
        tax2 {
          id
          label
        }
      }
    }
  `;

  static GET_LEDGER_CONNECTION = gql`
    query ledgers(
      $companyId: ID!
      $id: ID!
      $journal: String
      # $ecritureLinesFilter: EcritureLineWhereInput
      $first: Int
      $skip: Int
    ) {
      ledgerTiersesConnection(
        companyId: $companyId
        tiersId: $id
        journal: $journal
        first: $first
        skip: $skip
      ) {
        edges {
          node {
            id
            currency { id }
            ecritureLines {
              id
              libelle
              journal
              amount
              dateOperation
              labelLettrage
              dateLettrage
              company {
                id
                currency {
                  id
                }
              }
              bankTransaction {
                id
                bankAccount {
                  id
                  name
                  syncAccount
                  importedAccount
                  currency {id}
                }
                providerTransaction {
                  id
                }
                amount
                currency {
                  id
                }
                attachment {
                  id
                }
                bankTransactionLines {
                  id
                  valueHT
                  valueTax
                  amount
                  tiers {id name}
                  companyCurrencyAmount
                }
              }
              expense {
                id
                totalTTC
                currency {
                  id
                }
                dateEcheance
                attachment {
                  id
                }
                withoutProof
                numeroPiece
                status
              }
              invoice {
                id
                totalTTC
                currency {
                  id
                }
                date
                dateEcheance
                numeroPiece
              }
            }
          }
        }
      }
    }
  `;


  static GET_LEDGER_CATEGORY_CONNECTION_V2 = gql`
    query ledgers(
      $companyId: ID!
      $id: ID!
      $journal: String
      $first: Int
      $skip: Int
    ) {
      ledgerCategoriesConnectionV2(
        companyId: $companyId
        categoryId: $id
        journal: $journal
        first: $first
        skip: $skip
      ) {
        pageInfo {
          hasNextPage hasPreviousPage startCursor endCursor
        }
        edges {
          node {                        
            id
            libelle
            journal
            amount
            dateOperation
            labelLettrage
            dateLettrage
            category {
              id
              ids
              categoryFamily {
                id
                ids
                invoiceCategory
                expenseCategory
                clientCategory
                supplierCategory
                collaboratorCategory
                administrable
              }
            }
            company {
              id
              currency {
                id
              }
            }
            project {
              id
              name
            }
            tiersClient{
              id
              name
            }
            tiers {
              id
              name
            }
            bankTransaction {
              id
              bankAccount {
                id
                name
                currency {
                  id
                }
              }
              providerTransaction {
                id
              }
              amount
              companyCurrencyAmount
              currency {
                id
              }
              attachment {
                id
              }
              bankTransactionLines {
                id 
                numLine
                valueHT
                amount
                category {
                  id
                  ids 
                }                
              }
            }
            expense {
              id
              totalTTC
              companyCurrencyTotalTTC
              currency {
                id
              }
              dateEcheance
              attachment {
                id
              }
              withoutProof
              expenseLines {
                id
                numLine
                valueHT
                category {
                  id
                  ids          
                }  
              }
            }
            invoice {
              id
              totalTTC
              companyCurrencyTotalTTC
              currency {
                id
              }
              dateEcheance
              invoiceLines {
                id 
                numLine
                prixTotalHTApresRemise
                article {
                  id
                  category {
                    id
                    ids          
                  }                
                }
              }
            }            
          }
        }
      }
    }
  `;

  static GET_LEDGER_CATEGORY_CONNECTION = gql`
    query ledgers(
      $companyId: ID!
      $id: ID!
      $journal: String
      $first: Int
      $skip: Int
    ) {
      ledgerCategoriesConnection(
        companyId: $companyId
        categoryId: $id
        journal: $journal
        first: $first
        skip: $skip
      ) {
        pageInfo {
          hasNextPage hasPreviousPage startCursor endCursor
        }
        edges {
          node {
            id
            ids
            categoryFamily {
              id
              ids
              invoiceCategory
              expenseCategory
              clientCategory
              supplierCategory
              collaboratorCategory
              administrable
            }
            ecritureLines {
              id
              libelle
              journal
              amount
              dateOperation
              labelLettrage
              dateLettrage
              company {
                id
                currency {
                  id
                }
              }
              project {
                id
                name
              }
              tiersClient{
                id
                name
              }
              tiers {
                id
                name
              }
              bankTransaction {
                id
                bankAccount {
                  id
                  name
                  currency {
                    id
                  }
                }
                providerTransaction {
                  id
                }
                amount
                companyCurrencyAmount
                currency {
                  id
                }
                attachment {
                  id
                }
                bankTransactionLines {
                  id 
                  numLine
                  valueHT
                  amount
                  category {
                    id
                    ids 
                  }                
                }
              }
              expense {
                id
                totalTTC
                companyCurrencyTotalTTC
                currency {
                  id
                }
                dateEcheance
                attachment {
                  id
                }
                withoutProof
                expenseLines {
                  id
                  numLine
                  valueHT
                  category {
                    id
                    ids          
                  }  
                }
              }
              invoice {
                id
                totalTTC
                companyCurrencyTotalTTC
                currency {
                  id
                }
                dateEcheance
                invoiceLines {
                  id 
                  numLine
                  prixTotalHTApresRemise
                  article {
                    id
                    category {
                      id
                      ids          
                    }                
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  static GET_CATEGORY_PREVIOUS_NEXT = gql`
    query getCategoryPreviousNext($companyId: ID!, $categoryId: ID!) {
      getCategoryPreviousNext(companyId: $companyId, categoryId: $categoryId) {
        id
        previousId
        previousIdForBudget
        nextId
        nextIdForBudget
      }
    }
  `;

  static GET_EXPENSE_PREVIOUS_NEXT = gql`
    query getExpensePreviousNext($companyId: ID!, $expenseId: ID!) {
      getExpensePreviousNext(companyId: $companyId, expenseId: $expenseId) {
        id
        previousId
        nextId
      }
    }
  `;

  static GET_TIERS_PREVIOUS_NEXT = gql`
    query getTiersPreviousNext($companyId: ID!, $tiersId: ID!) {
      getTiersPreviousNext(companyId: $companyId, tiersId: $tiersId) {
        id
        previousId
        previousIdForBudget
        nextId
        nextIdForBudget
      }
    }
  `;

  static GET_SUPPLIER_CONNECTION = gql`
    query suppliers($companyId: ID!, $tiersId: ID!, $first: Int, $skip: Int) {
      supplierTiersesConnection(
        companyId: $companyId
        first: $first
        skip: $skip
        tiersId: $tiersId
      ) {
        edges {
          node {
            id
            name
            resteDu
            enRetard
            devisEnCours
            group
            currency {
              id
            }
            company {
              id
              currency {
                id
              }
            }
            addresses {
              id
              address
              country {
                id
                label
              }
            }
            expenseLateCount
            expenseDueCount
            xtraData
            supplier {
              id
              contacts {
                id
                email
                telFixe
                telMobile
                job
              }
              xtraData
            }
          }
        }
      }
    }
  `;

  static GET_CLIENT_CONNECTION = gql`
    query clients(
      $companyId: ID!
      $tiersId: ID!
      $first: Int
      $skip: Int
      $showYearBudget: Boolean
    ) {
      clientTiersesConnection(
        companyId: $companyId
        tiersId: $tiersId
        first: $first
        skip: $skip
        showYearBudget: $showYearBudget
      ) {
        aggregate {
          count
        }
        edges {
          node {
            id
            name
            resteDu
            enRetard
            devisEnCours
            pastDue
            budgetCurrent
            budgetNext
            invoiceLateCount
            invoiceDueCount
            group
            currency {
              id
            }
            company {
              id
              currency {
                id
              }
            }
            addresses {
              id
              address
              country {
                id
                label
              }
            }
            xtraData
            client {
              id
              defaultTax1 {
                id
                valuePourcent
              }
              defaultTax2 {
                id
                valuePourcent
              }
              language {
                id
                code
              }
              dateLanguage {
                id
                code
              }
              contacts {
                id
                name
                email
                telFixe
                telMobile
                job
              }
              relanceAuto
              lastRecipients
              taxIdemCompany
              collaboratorRespCom {
                id
		            role
                telFixe
                telMobile
                tiers {
                  id
                  name
                  firstname
                  lastname
                  email                
                }
              }
              xtraData
            }
          }
        }
      }
    }
  `;

  static GET_ODOO_PARTNER_CONNECTION = gql`
    query odooPartners(
      $companyId: ID!
      $tiersId: ID!
      $first: Int
      $skip: Int
    ) {
      odooPartnerTiersesConnection(
        companyId: $companyId
        tiersId: $tiersId
        first: $first
        skip: $skip
      ) {
        aggregate {
          count
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          node {
            id
            name            
            firstname
            lastname            
            currency {
              id
            }
            company {
              id
              currency {
                id
              }
            }            
            xtraData
            client {
              id          
              taxIdemCompany
              defaultTax1 {
                id
                valuePourcent
                label
              }
              defaultTax2 {
                id
                valuePourcent
                label
              }
              xtraData
            }
            supplier {
              id           
              taxIdemCompany
              defaultTax1 {
                id
                valuePourcent
                label
              }
              defaultTax2 {
                id
                valuePourcent
                label
              }
              xtraData
            }
            collaborator {
              id
              role              
              taxIdemCompany
              defaultTax1 {
                id
                valuePourcent
                label
              }
              defaultTax2 {
                id
                valuePourcent
                label
              }
              xtraData
            }
          }
        }
      }
    }
  `;

  static GET_ODOO_PARTNER = gql`
    query getOdooPartner($id: ID) {
      tiers(where: { id: $id }) {
        id
        name
        currency {
          id
        }
        company {
          id
          currency {
            id
          }
        }
        xtraData
        client {
          id
          taxIdemCompany
          defaultTax1 {
            id
            valuePourcent
            label
          }
          defaultTax2 {
            id
            valuePourcent
            label
          }
        }
        supplier {
          id
          taxIdemCompany
          defaultTax1 {
            id
            valuePourcent
            label
          }
          defaultTax2 {
            id
            valuePourcent
            label
          }
        }
        collaborator {
          id
          role
          taxIdemCompany
          defaultTax1 {
            id
            valuePourcent
            label
          }
          defaultTax2 {
            id
            valuePourcent
            label
          }
          xtraData
        }
      }
    }
  `;

  static GET_COLLABORATOR_CONNECTION = gql`
    query collaborators(
      $companyId: ID!
      $comptableOnly: Boolean
      $tiersId: ID!
      $first: Int
      $skip: Int
    ) {
      collaboratorTiersesConnection(
        companyId: $companyId
        comptableOnly: $comptableOnly
        tiersId: $tiersId
        first: $first
        skip: $skip
      ) {
        aggregate {
          count
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          node {
            id
            name
            email
            firstname
            lastname
            resteDu
            enRetard
            devisEnCours
            currency {
              id
            }
            company {
              id
              currency {
                id
              }
            }
            expenseLateCount
            expenseDueCount
            xtraData
            collaborator {
              id
              role
              telFixe
              telMobile
              invite
              taxIdemCompany
              defaultTax1 {
                id
                valuePourcent
                label
              }
              defaultTax2 {
                id
                valuePourcent
                label
              }
              xtraData
            }
          }
        }
      }
    }
  `;

  static GET_ALL_COLLABORATORS = gql`
    query GetAllCollaborators(
      $companyId: ID!
      $filter: TiersWhereInput!
      $nullValue: ID
    ) {
      _tiersesMeta(
        where: {
          AND: [
            $filter
            { company: { id: $companyId } }
            { collaborator: { id_not: $nullValue } }
          ]
        }
      ) {
        count
      }

      company(where: { id: $companyId }) {
        id
        tierses(where: $filter, orderBy: name_ASC) {
          id
          name
          email
          firstname
          lastname
          xtraData
          collaborator {
            id
            role
            telFixe
            telMobile
            xtraData
          }
        }
      }
    }
  `;

  static CONNECT_COLLABORATOR_MUTATION = gql`
    mutation ConnectCollaboratorSupplier(
      $id: ID!
      $tax1Id: ID
      $tax2Id: ID
      $connectTax1: Boolean!
      $connectTax2: Boolean!
      $disconnectTax1: Boolean!
      $disconnectTax2: Boolean!      
    ) {
      defaultTax1: updateCollaborator(
        where: { id: $id }
        data: { defaultTax1: { connect: { id: $tax1Id } } }
      ) @include(if: $connectTax1) {
        id
        defaultTax1 {
          id
        }
      }
      defaultTax1Disconnected: updateCollaborator(
        where: { id: $id }
        data: { defaultTax1: { disconnect: $disconnectTax1 } }
      ) @include(if: $disconnectTax1) {
        id
        defaultTax1 {
          id
        }
      }
      defaultTax2: updateCollaborator(
        where: { id: $id }
        data: { defaultTax2: { connect: { id: $tax2Id } } }
      ) @include(if: $connectTax2) {
        id
        defaultTax2 {
          id
        }
      }
      defaultTax2Disconnected: updateCollaborator(
        where: { id: $id }
        data: { defaultTax2: { disconnect: $disconnectTax2 } }
      ) @include(if: $disconnectTax2) {
        id
        defaultTax2 {
          id
        }
      }
    }
  `;

  static UPDATE_COLLABORATOR_MUTATION = gql`
    mutation UpdateCollaborator(
      $id: ID!
      $collaboratorId: ID!
      $email: String
      $firstName: String
      $lastName: String
      $name: String
      $fixPhone: String
      $mobilePhone: String
      $iban: String
      $swift: String
      $currencyId: ID
      $role: RoleEnum
      $invite: Boolean
      $notifBankTransactions: Boolean
      $notifBankAlerts: Boolean
      $taxIdemCompany: Boolean
      $xtraData: String
    ) {
      updateCollaborator(
        where: { id: $collaboratorId }
        data: {
          telFixe: $fixPhone
          telMobile: $mobilePhone
          role: $role
          invite: $invite
          taxIdemCompany: $taxIdemCompany
          tiers: {
            update: {
              email: $email
              firstname: $firstName
              lastname: $lastName
              name: $name
              iban: $iban
              swift: $swift
              xtraData: $xtraData
            }
          }
        }
      ) {
        id
        telFixe
        telMobile
        role
        invite
        tiers {
          id
          firstname
          lastname
          name
          email
          iban
          swift
          xtraData
          currency {
            id
          }
          company {
            id
          }
        }
      }

      updateTiers(
        where: { id: $id }
        data: { currency: { connect: { id: $currencyId } } }
      ) {
        id
        currency {
          id
        }
      }

      setNotifBank(
        tiersId: $id
        notifBankTransactions: $notifBankTransactions
        notifBankAlerts: $notifBankAlerts
      ){
        result
      }
    }
  `;

  static GET_COLLABORATOR = gql`
    query getCollaborator($id: ID) {
      tiers(where: { id: $id }) {
        id
        firstname
        lastname
        name
        email
        iban
        swift
        currency {
          id
        }
        company {
          id
          currency {
            id
          }
        }
        xtraData
        collaborator {
          id
          telFixe
          telMobile
          role
          invite
          taxIdemCompany
          defaultTax1 {
            id
            valuePourcent
            label
          }
          defaultTax2 {
            id
            valuePourcent
            label
          }
          xtraData
          #notifBankTransactions
          #notifBankAlerts
        }
      }
    }
  `;

  static GET_TIERS_COLLABORATOR_MAIL_NOTIF = gql`
    query getTiersCollaboratorMailNotif($id: ID!) {
      getTiersCollaboratorMailNotif(id: $id) {
        notifBankTransactions
        notifBankAlerts
      }
    }
  `;

  static GetCurrencyByIdForCurrencyInput = gql`
    query GetCurrency($currencyId: ID!) {
      currency(where: { id: $currencyId }) {
        id
        symbol
        decimalSeparator
        thousandSeparator
      }
    }
  `;

  // static UpdateClient = gql`
  //   mutation updateClient(
  //     $clientId: ID!
  //     $defaultTermNetsFinDeMois: TermNetsFinDeMoisEnum
  //     $defaultTermDelaisPaiement: TermDelaisDePaiementEnum
  //     $siret: String
  //     $codeAPE: String
  //     $numeroTVA: String
  //     $language: ID
  //     $relanceAuto: Boolean
  //   ) {
  //     updateClient(
  //       where: { id: $clientId }
  //       data: {
  //         defaultTermNetsFinDeMois: $defaultTermNetsFinDeMois
  //         defaultTermDelaisPaiement: $defaultTermDelaisPaiement
  //         siret: $siret
  //         codeAPE: $codeAPE
  //         numeroTVA: $numeroTVA
  //         language: { connect: { id: $language } }
  //         relanceAuto: $relanceAuto
  //       }
  //     ) {
  //       id
  //       defaultTermNetsFinDeMois
  //       defaultTermDelaisPaiement
  //       siret
  //       codeAPE
  //       numeroTVA
  //       language {
  //         id
  //         code
  //       }
  //       relanceAuto
  //     }
  //   }
  // `;

  static getProject = gql`
    query getProject($companyId: ID, $projectId: ID) {
      company(where: { id: $companyId }) {
        id

        projects(where: { id: $projectId }) {
          id
          name
          active
          projectType
          dateFinPrevue
          tiersClient {
            id
            name
          }
          tiersCollaborator {
            id
            name
          }
          invoices(first:1){id}
          quotations(first:1){id}
          expenseLines(first:1){id}
          ecritureLines(first:1){id}
          bankTransactionLines(first:1){id}
          budgetItems{id budgetType}
          budgetItemSituations(first:1){id}
        }
        id
      }
    }
  `;

  static deleteProject = gql`
    mutation deleteProject($id: ID!) {
      deleteProjectAfterCheck(where: { id: $id }) {
        result
      }
    }
  `;

  static updateProject = gql`
    mutation updateProject(
      $projectId: ID!
      $name: String!
      $active: Boolean
      $dateFinPrevue: DateTime
      $projectType: String
    ) {
      updateProject(
        where: { id: $projectId }
        data: {
          name: $name
          active: $active
          dateFinPrevue: $dateFinPrevue
          projectType: $projectType
        }
      ) {
        id
        name
        active
        dateFinPrevue
        projectType
        tiersClient {
          id
        }
        tiersCollaborator {
          id
        }
      }
    }
  `;

  static reaffectProject = gql`
    mutation reaffectProject(
      $companyId: ID!
      $projectId: ID!
      $newProjectId: ID
      $newTiersClientId: ID
    ) {
      reaffectProject(
        companyId: $companyId
        projectId: $projectId
        newProjectId: $newProjectId
        newTiersClientId: $newTiersClientId      
      ) {
        result
        warning
      }
    }
  `;

  static reaffectCategory = gql`
    mutation reaffectCategory(
      $companyId: ID!
      $ecritureLineIds: [ID]
      $categoryId: ID
      $newCategoryId: ID
    ) {
      reaffectCategory(
        companyId: $companyId
        ecritureLineIds: $ecritureLineIds
        categoryId: $categoryId
        newCategoryId: $newCategoryId
      ) {
        result
        warning
      }
    }
  `;

  static reaffectClientProjectCategory = gql`
    mutation reaffectClientProjectCategory(
      $companyId: ID!
      $ecritureLineIds: [ID]
      $projectId: ID
      $newProjectId: ID
      $tiersClientId: ID
      $newTiersClientId: ID
    ) {
      reaffectClientProjectCategory(
        companyId: $companyId
        ecritureLineIds: $ecritureLineIds
        projectId: $projectId
        newProjectId: $newProjectId
        tiersClientId: $tiersClientId
        newTiersClientId: $newTiersClientId
      ) {
        result
        warning
      }
    }
  `;

  static reaffectOnlyProjectCategory = gql`
    mutation reaffectOnlyProjectCategory(
      $companyId: ID!
      $ecritureLineIds: [ID]
      $projectId: ID
      $newProjectId: ID
    ) {
      reaffectOnlyProjectCategory(
        companyId: $companyId
        ecritureLineIds: $ecritureLineIds
        projectId: $projectId
        newProjectId: $newProjectId
      ) {
        result
        warning
      }
    }
  `;


  static CREATE_EXPENSE_LINE_MUTATION = gql`
    mutation CreateExpenseLine(
      $expenseId: ID!
      $categoryId: ID
      $valueHT: Float
      $numLine: Int
    ) {
      createExpenseLine(
        data: {
          expense: { connect: { id: $expenseId } }
          category: { connect: { id: $categoryId } }
          valueHT: $valueHT
          numLine: $numLine
        }
      ) {
        id
        expense {
          id
        }
        category {
          id
        }
        valueHT
        numLine
      }
    }
  `;

  static UPDATE_EXPENSE_LINE_MUTATION = gql`
    mutation UpdateExpenseLine(
      $id: ID!
      $expenseId: ID
      $categoryId: ID
      $valueHT: Float
      $numLine: Int
    ) {
      updateExpenseLine(
        where: { id: $id }
        data: {
          expense: { connect: { id: $expenseId } }
          category: { connect: { id: $categoryId } }
          valueHT: $valueHT
          numLine: $numLine
        }
      ) {
        id
        category {
          id
        }
        valueHT
        numLine
      }
    }
  `;

  static DELETE_EXPENSE_LINE_MUTATION = gql`
    mutation DeleteExpenseLine($id: ID!) {
      deleteExpenseLine(where: { id: $id }) {
        id
      }
    }
  `;
  static GET_ENUM_VALUES = gql`
    query GetEnumValues($enumName: String!) {
      __type(name: $enumName) {
        name
        enumValues {
          name
        }
      }
    }
  `;

  static DeleteCompany = gql`
    mutation deleteCompany($companyId: ID!) {
      deleteCompany(where: { id: $companyId }) {
        id
        name
      }
    }
  `;

  static updateCompanyLogo = gql`
    mutation updateCompanyLogo(
      $companyId: ID!
      $bucket: String
      $key: String
      $label: String
      $path: String
      $logoId: ID
    ) {
      updateCompany(
        where: { id: $companyId }
        data: {
          logoes: {
            update: [
              {
                where: { id: $logoId }
                data: { bucket: $bucket, key: $key, path: $path, label: $label }
              }
            ]
          }
        }
      ) {
        id
        logoes {
          id
          bucket
          key
          label
          path
        }
      }
    }
  `;

  static createCompanyLogo = gql`
    mutation createCompanyLogo(
      $companyId: ID!
      $bucket: String
      $key: String
      $label: String
      $path: String
    ) {
      updateCompany(
        where: { id: $companyId }
        data: {
          logoes: {
            create: [{ bucket: $bucket, key: $key, label: $label, path: $path }]
          }
        }
      ) {
        id
        logoes {
          id
          bucket
          key
          label
          path
        }
      }
    }
  `;

  static getTierForLedgerList = gql`
    query tiersForLedgerList($id: ID!) {
      tiers(where: { id: $id }) {
        id
        name
      }
    }
  `;

  // static getTierForLedgerList = gql`
  //   query tiersForLedgerList($id: ID!) {
  //     tiers(where: { id: $id }) {
  //       name
  //     }
  //   }
  // `;

  static getExpenseTiersSettings = gql`
    query expenseTiersSettings($companyId: ID!, $tiersId: ID) {
      expenseTiersSettings(companyId: $companyId, tiersId: $tiersId) {
        lines {
          id
          category
        }
        taxPieces {
          id
          taux
          tax {
            id
          }
        }
      }
    }
  `;

  static createProviderAccount = gql`
    mutation createProviderAccount(
      $companyId: ID!
      $data: ProviderAccountCreateInput!
    ) {
      createProviderAccount(companyId: $companyId, data: $data) {
        id
        accountId
        iban
        number
        solde
        name
        active
      }
    }
  `;

  static unsyncProviderAccount = gql`
    mutation unsyncProviderAccount(
      $companyId: ID!
      $where: ProviderAccountWhereUniqueInput!
    ) {
      unsyncProviderAccount(where: $where, companyId: $companyId) {
        id
      }
    }
  `;

  static updateProviderAccount = gql`
    mutation updateProviderAccount(
      $companyId: ID!
      $data: ProviderAccountUpdateInput!
      $where: ProviderAccountWhereUniqueInput!
    ) {
      updateProviderAccount(where: $where, companyId: $companyId, data: $data) {
        id
        accountId
        bankAccount {
          id
        }
        iban
        number
        solde
        name
        active
        syncAccount
      }
    }
  `;

  static CREATE_BANK_AND_PROVIDER_MUTATION = gql`
    mutation CreateBankAccount(
      $companyId: ID!
      $name: String
      $bic: String
      $iban: String
      $number: String
      $alertMinMontant: Float
      $alertMaxMontant: Float
      $alertMinSolde: Float
      $alertMaxSolde: Float
      $codeJournal: String
      $typeBankAccount: String
      $currency: ID
      $provider: BankProviderEnum
      $accountId: String
    ) {
      createBankAccount(
        data: {
          name: $name
          originalName: $name
          dateLastUpdate: null
          dateCloture: null
          bic: $bic
          iban: $iban
          number: $number
          solde: 0.0
          alertMinMontant: $alertMinMontant
          alertMaxMontant: $alertMaxMontant
          alertMinSolde: $alertMinSolde
          alertMaxSolde: $alertMaxSolde
          codeJournal: $codeJournal
          syncAccount: false
          importedAccount: true
          typeBankAccount: $typeBankAccount
          active: true
          accountLabel: ""
          company: { connect: { id: $companyId } }
          currency: { connect: { id: $currency } }
          providerAccount: {
            create: {
              name: $name
              originalName: $name
              accountId: $accountId
              connectionId: ""
              error: ""
              errorMessage: ""
              dateError: null
              bic: $bic
              iban: $iban
              number: $number
              solde: 0.0
              syncAccount: false
              importedAccount: true
              typeBankAccount: $typeBankAccount
              active: true
              provider: $provider
              dateFirstUpdate: null
              dateLastUpdate: null
              company: { connect: { id: $companyId } }
              currency: { connect: { id: $currency } }
            }
          }
        }
      ) {
        id
        providerAccount {
          id
        }
      }
    }
  `;

  static createBankAccountFromProviderAccount = gql`
    mutation createBankAccountFromProviderAccount(
      $companyId: ID!
      $providerId: ID!
    ) {
      createBankAccountFromProviderAccount(
        companyId: $companyId
        providerId: $providerId
      ) {
        id
      }
    }
  `;

  static syncronizeProviderAccounts = gql`
    mutation syncronizeProviderAccounts($companyId: ID!) {
      syncronizeProviderAccounts(companyId: $companyId)
    }
  `;

  static createAccessToken = gql`
    mutation createAccessToken($companyId: ID!, $accessToken: String!) {
      createAccessToken(companyId: $companyId, accessToken: $accessToken)
    }
  `;

  static resetAccessToken = gql`
    mutation resetAccessToken($companyId: ID!) {
      resetAccessToken(companyId: $companyId)
    }
  `;

  static createAccessToken2 = gql`
    mutation createAccessToken(
      $companyId: ID!
      $accessToken: String
      $userId: Int
      $active: Boolean
    ) {
      updateCompany(
        where: { id: $companyId }
        data: {
          biConnexion: {
            create: {
              accessToken: $accessToken
              userId: $userId
              active: $active
            }
          }
        }
      ) {
        id
      }
    }
  `;

  static getCostsReportData = gql`
    query getCostsReportData($companyId: ID!, $year: String, $cursor: String) {
      ecritureLinesConnectionForCosts(
        companyId: $companyId
        year: $year
        where: { company: { id: $companyId } }
        cursor: $cursor
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
          __typename
        }
        aggregate {
          count
          __typename
        }
        edges {
          node {
            id
            amount
            category {
              id
              ids
              name
              categoryFamily {
                id
                ids
                name
                __typename
              }
              __typename
            }
            tiers {
              id
              name
              group
              __typename
            }
            project {
              id
              name
              tiersClient {
                id
                name
                __typename
              }
              __typename
            }
            expense {
              id
              numeroPiece
              creator {
                id
                name
                __typename
              }
              __typename
            }
            tiersClient {
              id
              name
              __typename
            }
            dateOperation
            bankTransaction {
              id
              libelleLong
              bankAccount {
                id
                name
              }
            }
          }
          __typename
        }
        __typename
      }
    }
  `;

  static getSalesReportData = gql`
    query getSalesReportData($companyId: ID!, $year: String, $cursor: String) {
      ecritureLinesConnectionForSales(
        companyId: $companyId
        year: $year
        where: { company: { id: $companyId } }
        cursor: $cursor
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
          __typename
        }
        aggregate {
          count
          __typename
        }
        edges {
          node {
            id
            amount
            category {
              id
              ids
              name
              categoryFamily {
                id
                ids
                name
                __typename
              }
              __typename
            }
            tiers {
              id
              name
              group
              __typename
            }
            project {
              id
              name
              tiersClient {
                id
                name
                __typename
              }
              __typename
            }
            invoice {
              id
              numeroPiece
              creator {
                id
                name
              }
              vendeur {
                id
                name
                __typename
              }
              totalHTApresRemise  
              invoiceLines{     
                id       
                prixTotalHTApresRemise   
                quantity
                article {
                  id
                  name
                  __typename
                }
                __typename
              }
              __typename
            }
            article {
              id
              name
              __typename
            }
            dateOperation
            bankTransaction {
              id
              libelleLong
              bankAccount {
                id
                name
              }
            }
          }
          __typename
        }
        __typename
      }
    }
  `;

  static getEarningsReportData = gql`
    query getEarningsReportData(
      $companyId: ID!
      $year: String
      $cursor: String
    ) {
      ecritureLinesConnectionForEarnings(
        companyId: $companyId
        year: $year
        where: { company: { id: $companyId } }
        cursor: $cursor
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
          __typename
        }
        aggregate {
          count
          __typename
        }
        edges {
          node {
            id
            amount
            category {
              id
              ids
              name
              categoryFamily {
                id
                ids
                name
                __typename
              }
              __typename
            }
            tiers {
              id
              name
              group
              __typename
            }
            project {
              id
              name
              tiersClient {
                id
                name
                __typename
              }
              __typename
            }
            invoice {
              id
              numeroPiece
              vendeur {
                id
                name
                __typename
              }
              __typename
            }
            tiersClient {
              id
              name
              __typename
            }
            article {
              id
              name
            }
            dateOperation
            bankTransaction {
              id
              bankAccount {
                id
                name
              }
            }
            __typename
          }
          __typename
        }
        __typename
      }
    }
  `;

  static getRentabilityReportData = gql`
    query getRentabilityReportData(
      $companyId: ID!
      $year: String
      $cursor: String
    ) {
      ecritureLinesConnectionForRentability(
        companyId: $companyId
        year: $year
        where: { company: { id: $companyId } }
        cursor: $cursor
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        aggregate {
          count
        }
        edges {
          node {
            id
            amount
            tiers {
              id
              name
              client {
                id
              }
              group
            }
            tiersClient {
              id
              name
            }
            project {
              id
              name
              tiersClient {
                id
                name
              }
            }
            article {
              id
              name
            }
            dateOperation
            category {
              id
              ids
              name
              categoryFamily {
                id
                ids
                name
                reportCost
                reportEarnings
              }
            }
            invoice {
              id
              numeroPiece
              vendeur {
                id
                name
                __typename
              }
              __typename
            }
            bankTransaction {
              id
              libelleLong
              bankAccount {
                id
                name
              }
            }
            expense {
              id
              numeroPiece
              creator {
                id
                name
                __typename
              }
              __typename
            }
          }
        }
      }
    }
  `;

  static getTreasuryReportData = gql`
    query getTreasuryReportData(
      $companyId: ID!
      $year: String
      $cursor: String
    ) {
      ecritureLinesConnectionForTreasury(
        companyId: $companyId
        year: $year
        where: { company: { id: $companyId } }
        cursor: $cursor
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        aggregate {
          count
        }
        edges {
          node {
            id
            amount
            project {
              id
              name
            }
            tiers {
              id
              name
              group
              client {
                id
                collaboratorRespCom {
                  id
                  tiers {
                    name
                  }
                }
              }             
            }
            tiersClient {
              id
              name
              group
              client {
                id
                collaboratorRespCom {
                  id
                  tiers {
                    name
                  }
                }
              } 
            }
            category {
              id
              ids
              name
              categoryFamily {
                id
                ids
                name
              }
            }
            dateOperation
            bankTransaction {
              id
              libelleLong
              bankAccount {
                id
                name
              }
            }
            __typename
          }
        }
      }

      ecritureLinesConnectionForTreasury2(
        companyId: $companyId
        year: $year
        where: { company: { id: $companyId } }
        cursor: $cursor
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        aggregate {
          count
        }
        edges {
          node {
            id
            amount
            project {
              id
              name
            }
            tiers {
              id
              name
              group
              client {
                id
                collaboratorRespCom {
                  id
                  tiers {
                    name
                  }
                }
              }     
              __typename
            }
            tiersClient {
              id
              name
              group
              client {
                id
                collaboratorRespCom {
                  id
                  tiers {
                    name
                  }
                }
              } 
            }
            category {
              id
              ids
              name
              categoryFamily {
                id
                ids
                name
              }
            }
            dateOperation
            bankTransaction {
              id
              libelleLong
              bankAccount {
                id
                name
              }
            }
            invoice {
              id
              numeroPiece
            }
            expense {
              id
              numeroPiece
            }
            labelLettrage
            refEcriture
            __typename
          }
        }
      }
    }
  `;

  static getBudgetReportData = gql`
    query getBudgetReportData($companyId: ID!, $year: String, $cursor: String) {
      dataForBudgetChart(companyId: $companyId, year: $year, cursor: $cursor) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
          __typename
        }
        aggregate {
          count
        }
        edges {
          node {
            id
            company {
              id
            }
            year
            month
            amount
            dateSaisie
            tiers {
              id
              name
              group
            }
            tiersCollaborator {
              id
              name
            }
            project {
              id
              name
            }
            realValue
            previousYearRealValue
            previousYearBudgetAmount
            isDeleted
          }
        }
      }
    }
  `;

  static getBudgetCategoryReportData = gql`
    query getBudgetCategoryReportData(
      $companyId: ID!
      $year: String
      $cursor: String
    ) {
      dataForBudgetCategoryChart(
        companyId: $companyId
        year: $year
        cursor: $cursor
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
          __typename
        }
        aggregate {
          count
        }
        edges {
          node {
            id
            company {
              id
            }
            year
            month
            amount
            dateSaisie
            tiers {
              id
              name
              group
              client {
                id
              }
              supplier {
                id
              }
              collaborator {
                id
              }
            }
            category {
              id
              name
              ids
              generic
              sensHabituel
              categoryFamily {
                id
                ids
                name
              }
            }
            # tiersCollaborator {
            #   id
            #   name
            # }
            project {
              id
              name
            }
            tiersClient {
              id
              name
            }
            realValue
            previousYearRealValue
            previousYearBudgetAmount
            isDeleted
            # isReal
          }
        }
      }
    }
  `;

  // static getCompanyStatusData = gql`
  //   query getCompanyStatusData($companyId: ID!) {
  //     getCieStatData(
  //       companyId: $companyId
  //       where: { company: { id: $companyId } }
  //     ) {
  //       cash
  //       bankGreenNotifications
  //       bankRedNotifications
  //       bankErrorCount
  //       sellNotifications
  //       expenseNotifications
  //       expenseRedNotifications
  //     }
  //   }
  // `;

  static getCompanyStatusData = gql`
    query companyStatusData($companyId: ID!, $firstCall: Boolean) {
      companyStatusData(
        companyId: $companyId
        firstCall: $firstCall
      ) {
        countBanksTransactions
        countBankTransactionsAQualifier
        countBankTransactionsAConfirmer
        countBankTransactionsQualifie
        countBankTransactionsAJustifier
        countExpenses
        countExpensesACompleter
        countExpensesAValider
        countExpensesAPayer
        countExpensesAPayerWithoutAttachment
        countExpensesWithoutAttachment
        countQuotations
        countQuotations15Days
        countQuotations30Days
        countQuotations3Months
        countInvoices
        cash
        currencyId
        bankErrorDetected
        bankErrorMessage
        amountExpense
        amountInvoice
        firstCall
      }
    }
  `;

  static getBankCompanyStatusData = gql`
    query bankCompanyStatusData($companyId: ID!) {
      bankCompanyStatusData(
        companyId: $companyId
      ) {
        countBanksTransactions
        countBankTransactionsAQualifier
        bankAccountMaxAQualifier
        countBankTransactionsAConfirmer
        bankAccountMaxAConfirmer
        countBankTransactionsQualifie
        bankAccountMaxQualifie
        countBankTransactionsAJustifier 
        bankAccountMaxAJustifier   
        cash
        currencyId
        bankErrorDetected
        bankErrorMessage
      }
    }
  `;

  static getBankCompanyStatusDataLight = gql`
    query bankCompanyStatusDataLight($companyId: ID!) {
      bankCompanyStatusDataLight(
        companyId: $companyId
      ) {
        countBanksTransactions
        countBankTransactionsAQualifier
        bankAccountMaxAQualifier
        countBankTransactionsAConfirmer
        bankAccountMaxAConfirmer
        countBankTransactionsQualifie
        bankAccountMaxQualifie
        countBankTransactionsAJustifier 
        bankAccountMaxAJustifier   
        cash
        currencyId
        bankErrorDetected
        bankErrorMessage
      }
    }
  `;

  static getExpenseCompanyStatusData = gql`
    query expenseCompanyStatusData($companyId: ID!) {
      expenseCompanyStatusData(
        companyId: $companyId
      ) {        
        countExpenses
        countExpensesACompleter
        countExpensesAValider
        countExpensesAPayer
        countExpensesAPayerWithoutAttachment
        countExpensesWithoutAttachment
        amountExpense
        currencyId
      }
    }
  `;

  static getExpenseCompanyStatusDataLight = gql`
    query expenseCompanyStatusDataLight($companyId: ID!) {
      expenseCompanyStatusDataLight(
        companyId: $companyId
      ) {        
        countExpenses
        countExpensesACompleter
        countExpensesAValider
        countExpensesAPayer
        countExpensesAPayerWithoutAttachment
        countExpensesWithoutAttachment
        amountExpense
        currencyId
      }
    }
  `;

  static getQuotationCompanyStatusData = gql`
    query quotationCompanyStatusData($companyId: ID!) {
      quotationCompanyStatusData(
        companyId: $companyId
      ) {    
        countQuotations
        countQuotations15Days
        countQuotations30Days
        countQuotations3Months
        currencyId
      }
    }
  `;

  static getInvoiceCompanyStatusData = gql`
    query invoiceCompanyStatusData($companyId: ID!) {
      invoiceCompanyStatusData(
        companyId: $companyId
      ) {
        countInvoices
        amountInvoice
        currencyId
      }
    }
  `;




  static getExchangeRate = gql`
    query getExchangeRate(
      $date: DateTime
      $currencyId: ID
      $companyCurrencyId: ID
    ) {
      getExchangeRate(
        date: $date
        currencyId: $currencyId
        companyCurrencyId: $companyCurrencyId
      ) {
        value
      }
    }
  `;

  static isExpenseAlreadyExist = gql`
    query isExpenseAlreadyExist(
      $companyId: ID
      $expenseID: ID
      $tiersId: ID
      $date: DateTime
      $totalTTC: Float
      $currencyId: ID
    ) {
      isExpenseAlreadyExist(
        companyId: $companyId
        expenseID: $expenseID
        tiersId: $tiersId
        date: $date
        totalTTC: $totalTTC
        currencyId: $currencyId
      ) {
        value
      }
    }
  `;

  /*static preDeleteBankAccount = gql`
    mutation preDeleteBankAccount($bankAccountId: ID!) {
      preDeleteBankAccount(
        bankAccountId: $bankAccountId
        where: { id: $bankAccountId }
      ) {
        id
      }
    }
  `;
  */

  static deleteBankAccount = gql`
    mutation deleteBankAccount($bankAccountId: ID!) {
      deleteBankAccount(
        bankAccountId: $bankAccountId
        where: { id: $bankAccountId }
      ) {
        id
      }
    }
  `;

  static closeBankAccount = gql`
    mutation closeBankAccount($bankAccountId: ID!) {
      closeBankAccount(
        bankAccountId: $bankAccountId
        where: { id: $bankAccountId }
      ) {
        id
      }
    }
  `;

  static mergeBankAccount = gql`
    mutation mergeBankAccount($bankAccountId: ID!) {
      mergeBankAccount(
        bankAccountId: $bankAccountId
        where: { id: $bankAccountId }
      ) {
        id
      }
    }
  `;

  static refreshBankAccount = gql`
    mutation refreshBankAccount($bankAccountId: ID!) {
      refreshBankAccount(
        bankAccountId: $bankAccountId
        where: { id: $bankAccountId }
      ) {
        id
      }
    }
  `;

  static importBankTransactions = gql`
    mutation importBankTransactions($bankAccountId: ID!, $fileName: String!) {
      importBankTransactions(
        bankAccountId: $bankAccountId
        fileName: $fileName
        where: { id: $bankAccountId }
      ) {
        result
      }
    }
  `;

  static unsynchronizeBankAccount = gql`
    mutation unsynchronizeBankAccount($bankAccountId: ID!) {
      unsynchronizeBankAccount(
        bankAccountId: $bankAccountId
        where: { id: $bankAccountId }
      ) {
        id
      }
    }
  `;

  static checkCompany = gql`
    mutation checkCompany($companyId: ID!) {
      checkCompany(companyId: $companyId, where: { id: $companyId }) {
        id
      }
    }
  `;

  static getDashboardInfos = gql`
    query getDashboardInfos($companyId: ID!) {
      getDashboardInfos(companyId: $companyId, where: { id: $companyId }) {
        id
        name
        expenses {
          id
          status
          attachment {
            id
          }
        }
        bankTransactions {
          id
          status
        }
        quotations {
          id
        }
        invoices {
          id
        }
      }
    }
  `;

  static getNewCollaboratorDataFromUsers = gql`
    query getNewCollaboratorDataFromUsers($companyId: ID) {
      getNewCollaboratorDataFromUsers(
        companyId: $companyId
        where: { id: $companyId }
      ) {
        name
        firstname
        telFixe
        telMobile
        email
      }
    }
  `;

  static createExpenseAttachment = gql`
    mutation createExpenseAttachment(
      $expenseId: ID!
      $bucket: String
      $key: String
      $label: String
      $path: String
    ) {
      updateExpense(
        where: { id: $expenseId }
        data: {
          attachment: {
            create: { bucket: $bucket, key: $key, label: $label, path: $path }
          }
        }
      ) {
        id
        attachment {
          id
          bucket
          key
          label
          path
        }
      }
    }
  `;

  static createAttachment = gql`
    mutation createAttachment(
      $bucket: String
      $key: String
      $label: String
      $path: String
      $companyId: ID!
    ) {
      createAttachment(
        data: {
          bucket: $bucket
          key: $key
          label: $label
          path: $path
          company: { connect: { id: $companyId } }
        }
      ) {
        id
        bucket
        key
        label
        path
      }
    }
  `;

  static updateAttachment = gql`
    mutation updateAttachment(
      $id: ID!
      $bucket: String
      $key: String
      $label: String
      $path: String
    ) {
      updateAttachment(
        where: { id: $id }
        data: { bucket: $bucket, key: $key, label: $label, path: $path }
      ) {
        id
        bucket
        key
        label
        path
      }
    }
  `;

  static deleteAttachment = gql`
    mutation deleteAttachment(
      $id: ID!
    ) {
      deleteAttachment(
        where: { id: $id }    
      ) {
        id
      }
    }
  `;



  static connectAttachmentToExpense = gql`
    mutation connectAttachmentToExpense($id: ID!, $expenseId: ID!) {
      updateAttachment(
        where: { id: $id }
        data: { expense: { connect: { id: $expenseId } } }
      ) {
        id
        expense {
          id
        }
      }
    }
  `;

  static connectAttachmentToInvoice = gql`
    mutation connectAttachmentToInvoice($id: ID!, $invoiceId: ID!) {
      updateAttachment(
        where: { id: $id }
        data: { invoice: { connect: { id: $invoiceId } } }
      ) {
        id
        invoice {
          id
          attachment {
            id
            path
            bucket
            label
            key
          }
        }
      }
    }
  `;

  static connectAttachmentToQuotation = gql`
    mutation connectAttachmentToQuotation($id: ID!, $quotationId: ID!) {
      updateAttachment(
        where: { id: $id }
        data: { quotation: { connect: { id: $quotationId } } }
      ) {
        id
        quotation {
          id
        }
      }
    }
  `;

  static connectAttachmentToBankTransaction = gql`
    mutation connectAttachmentToBankTransaction(
      $id: ID!
      $bankTransactionId: ID!
    ) {
      updateAttachment(
        where: { id: $id }
        data: { payment: { connect: { id: $bankTransactionId } } }
      ) {
        id
        payment {
          id
        }
      }
    }
  `;
  static deleteExpenseAttachment = gql`
    mutation deleteExpenseAttachment($id: ID!) {
      deleteExpenseAttachment(where: { id: $id }) {
        id
      }
    }
  `;
  static deleteBankTransactionAttachment = gql`
    mutation deleteBankTransactionAttachment($id: ID!) {
      deleteBankTransactionAttachment(where: { id: $id }) {
        id
      }
    }
  `;

  static GET_ACCOUNTINGPLAN_DATA = gql`
    query GetAllAccountingPlan(
      $companyId: ID!
      $filter: AccountingPlanWhereInput!
    ) {
      _allAccountingPlansMeta(
        where: { AND: [$filter, { company: { id: $companyId } }] }
      ) {
        count
      }
      company(where: { id: $companyId }) {
        id
        accountingPlans(where: $filter) {
          id
          category {
            id
            ids
            name
          }
          libelle
          accountLabel
          aux
          xtraData
        }
      }
    }
  `;

  static CLEAN_ACCOUNTINGPLAN_MUTATION = gql`
    mutation cleanAccountingPlan(
      $companyId: ID!
    ) {
      cleanAccountingPlan( companyId: $companyId ) {
        result
      }
    }
  `;

  static RESET_ACCOUNTINGPLAN_CLIENT_AUX_MUTATION = gql`
    mutation resetClientAux(
      $companyId: ID!
    ) {
      resetClientAux( companyId: $companyId ) {
        result
      }
    }
  `;

  static RESET_ACCOUNTINGPLAN_SUPPLIER_AUX_MUTATION = gql`
    mutation resetSupplierAux(
      $companyId: ID!
    ) {
      resetSupplierAux( companyId: $companyId ) {
        result
      }
    }
  `;

  static UPDATE_ACCOUNTINGPLAN_MUTATION = gql`
    mutation updateAccountingPlan(
      $id: ID!
      $accountLabel: String
      $aux: String
      $xtraData: String
    ) {
      updateAccountingPlan(
        where: { id: $id }
        data: { accountLabel: $accountLabel, aux: $aux, xtraData: $xtraData }
      ) {
        id
      }
    }
  `;

  static UPDATE_CODEJOURNAL_MUTATION = gql`
    mutation updateCodeJournal($id: ID!, $accountLabel: String) {
      updateCodeJournal(
        where: { id: $id }
        data: { accountLabel: $accountLabel, aux: $aux }
      ) {
        id
      }
    }
  `;

  static setManualLettrage = gql`
    mutation setManualLettrage(
      $ecritureLineIds: [EcritureLineWhereUniqueInput]
      $companyId: ID
    ) {
      setManualLettrage(
        ecritureLineIds: $ecritureLineIds
        companyId: $companyId
      ) {
        result
      }
    }
  `;

  static setManualDelettrage = gql`
    mutation setManualDelettrage(
      $ecritureLineIds: [EcritureLineWhereUniqueInput]
      $companyId: ID
    ) {
      setManualDelettrage(
        ecritureLineIds: $ecritureLineIds
        companyId: $companyId
      ) {
        result
      }
    }
  `;

  static autoLettrageTiers = gql`
    mutation autoLettrageTiers($companyId: ID, $tiersId: ID) {
      autoLettrageTiers(companyId: $companyId, tiersId: $tiersId) {
        result
      }
    }
  `;

  static createExpenseEcritures = gql`
    mutation createExpenseEcritures($expenseId: ID!, $fullUpdate: Boolean) {
      createExpenseEcritures(expenseId: $expenseId, fullUpdate: $fullUpdate)
    }
  `;

  static deleteExpenseEcritures = gql`
    mutation deleteExpenseEcritures($expenseId: ID!) {
      deleteExpenseEcritures(expenseId: $expenseId)
    }
  `;

  static createInvoiceEcritures = gql`
    mutation createInvoiceEcritures($invoiceId: ID!) {
      createInvoiceEcritures(invoiceId: $invoiceId)
    }
  `;

  static deleteInvoiceEcritures = gql`
    mutation deleteInvoiceEcritures($invoiceId: ID!) {
      deleteInvoiceEcritures(invoiceId: $invoiceId)
    }
  `;

  static createBankTransactionEcritures = gql`
    mutation createBankTransactionEcritures($bankTransactionId: ID!) {
      createBankTransactionEcritures(bankTransactionId: $bankTransactionId)
    }
  `;

  static deleteBankTransactionEcritures = gql`
    mutation deleteBankTransactionEcritures($bankTransactionId: ID!) {
      deleteBankTransactioneEcritures(bankTransactionId: $bankTransactionId)
    }
  `;

  static sendInvoiceAsEmail = gql`
    mutation sendInvoiceAsEmail(
      $emails: EmailRecipients
      $companyId: ID!
      $mailContent: String
      $mailObject: String
      $s3Path: String
      $s3Bucket: String
      $attachments: [String]
      $clientId: ID
    ) {
      sendInvoiceAsEmail(
        emails: $emails
        companyId: $companyId
        s3Path: $s3Path
        s3Bucket: $s3Bucket
        mailContent: $mailContent
        mailObject: $mailObject
        attachments: $attachments
        clientId: $clientId
      ) {
        result
      }
    }
  `;

  static SET_NOTIF_BANK = gql`
    mutation setNotifBank(
      $tiersId: ID!
      $notifBankTransactions: Boolean
      $notifBankAlerts: Boolean
    ) {
      setNotifBank(
        tiersId: $tiersId
        notifBankTransactions: $notifBankTransactions
        notifBankAlerts: $notifBankAlerts
      ) {
        result
      }
    }
  `;

  static createInvoicePDF = gql`
    mutation createInvoicePDF(      
      $companyId: ID!      
      $invoiceId: ID!
      $isQuotation: Boolean      
    ) {
      createInvoicePDF(
        companyId: $companyId
        invoiceId: $invoiceId
        isQuotation: $isQuotation        
      ) {
        result
        filename
        url
      }
    }
  `;

  static previewInvoicePDF = gql`
    mutation previewInvoicePDF(      
      $companyId: ID!      
      $invoiceId: ID!
      $isQuotation: Boolean      
    ) {
      previewInvoicePDF(
        companyId: $companyId
        invoiceId: $invoiceId
        isQuotation: $isQuotation        
      ) {
        result
        filename
        url
      }
    }
  `;

  static linkedPieces = gql`
    query linkedPieces($referenceDossier: String!, $companyId: ID!) {
      linkedPieces(referenceDossier: $referenceDossier, companyId: $companyId) {
        linkedQuotations {
          id
          numeroPiece
        }
        linkedInvoices {
          id
          typeFacture
          numeroPiece
        }
      }
    }
  `;

  static getContactByEmail = gql`
    query contacts($companyId: ID!, $email: String) {
      contacts(companyId: $companyId, email: $email) {
        id
        company {
          id
        }
        email
        client {
          id
          lastRecipients
        }
      }
    }
  `;

  static getTaxesReportData = gql`
    query getTaxesReportData(
      $companyId: ID!
      $dateFrom: DateTime
      $dateTo: DateTime
      $cursor: String
    ) {
      ecritureLinesConnectionForTaxes(
        companyId: $companyId
        dateFrom: $dateFrom
        dateTo: $dateTo
        where: { company: { id: $companyId } }
        cursor: $cursor
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        aggregate {
          count
        }
        edges {
          node {
            id
            amount
            expense {
              id
              numeroPiece
              description
              tiers {
                id
                name
              }
              ecritureLines {
                id
                # numLine
                amount
                dateLettrage
                taxes {
                  id
                  label
                  valuePourcent
                  mode
                }
                category {
                  id
                  ids
                  categoryFamily {
                    id
                    ids
                    # taxSurFrais
                    # taxSurImmos
                    # taxCollectee
                  }
                }
              }
            }
            invoice {
              id              
              tiersClient {
                id
                name
                addresses {
                  id
                  country {
                    id
                    label
                  }
                }
              }
              numeroPiece
              titre
              
              ecritureLines {
                id
                # numLine
                amount
                dateLettrage
                taxes {
                  id
                  label
                  valuePourcent
                  mode
                }
                category {
                  id
                  ids
                  categoryFamily {
                    id
                    ids
                    # taxSurFrais
                    # taxSurImmos
                    # taxCollectee
                  }
                }
              }
            }
            bankTransaction {
              id
              amount
              companyCurrencyAmount
              libelleLong
              bankAccount {
                id
                name
              }
              bankTransactionLines{
                id
                numLine
                amount
                valueHT                
                taxPieces{
                  id
                  amount
                  tax {
                    id
                    label
                    valuePourcent
                    mode
                  }
                }   
              } 
              ecritureLines {
                id
                # numLine
                amount
                dateOperation
                dateLettrage
                taxes {
                  id
                  label
                  valuePourcent
                  mode
                }
                category {
                  id
                  ids
                  categoryFamily {
                    id
                    ids
                    name
                    invoiceCategory
                    expenseCategory
                    clientCategory
                    supplierCategory
                    collaboratorCategory
                    taxCollectee
                    taxSurFrais
                    taxSurImmos
                    clientCategoryForEcriture
                    supplierCategoryForEcriture
                    collaboratorCategoryForEcriture
                    reportCost
                    reportSales
                    # taxSurFrais
                    # taxSurImmos
                    # taxCollectee
                  }
                }
              }
            }

            category {
              id
              ids
              # name
              categoryFamily {
                id
                ids
                name
                invoiceCategory
                expenseCategory
                clientCategory
                supplierCategory
                collaboratorCategory
                taxCollectee
                taxSurFrais
                taxSurImmos
                clientCategoryForEcriture
                supplierCategoryForEcriture
                collaboratorCategoryForEcriture
                reportCost
                reportSales
              }
            }
            dateOperation
            dateLettrage
            company {
              id
              taxes {
                id
                label
                valuePourcent
                active
                mode
              }
            }
          }
        }
      }
    }
  `;

  static createBudgetItems = gql`
    mutation createBudgetItems(
      $companyId: ID!
      $tiersId: ID!
      $projectId: ID
      $isReal: Boolean
      $items: [BudgetItemCreationList]
    ) {
      createBudgetItems(
        companyId: $companyId
        tiersId: $tiersId
        projectId: $projectId
        isReal: $isReal
        items: $items
      ) {
        result
      }
    }
  `;

  static createBudgetCategoryItems = gql`
    mutation createBudgetCategoryItems(
      $companyId: ID!
      $categoryId: ID
      $projectId: ID
      $tiersClientId: ID
      $tiersId: ID!
      $isReal: Boolean
      $items: [BudgetItemCreationList]
    ) {
      createBudgetCategoryItems(
        companyId: $companyId
        categoryId: $categoryId
        projectId: $projectId
        tiersClientId: $tiersClientId
        tiersId: $tiersId
        isReal: $isReal
        items: $items
      ) {
        result
      }
    }
  `;

  static createBudgetItemsBackup = gql`
    mutation createBudgetItemsBackup(
      $companyId: ID!
      $name: String
      $observations: String
      $dateDebut: DateTime
    ) {
      createBudgetItemsBackup(
        companyId: $companyId
        name: $name
        observations: $observations
        dateDebut: $dateDebut
      ) {
        result
      }
    }
  `;

  static changeBudgetProject = gql`
    mutation changeBudgetProject(
      $companyId: ID!
      $tiersId: ID!
      $projectId: ID
      $newProjectId: ID
    ) {
      changeBudgetProject(
        companyId: $companyId
        tiersId: $tiersId
        projectId: $projectId
        newProjectId: $newProjectId
      ) {
        result
      }
    }
  `;

  static getBudgetHistory = gql`
    mutation getBudgetHistory(
      $companyId: ID!
      $budgetType: BudgetTypeEnum
      $locale: String
    ) {
      getBudgetHistory(
        companyId: $companyId
        budgetType: $budgetType
        locale: $locale
      ) {
        result
        filename
        url
      }
    }
  `;

  static getBudgetHistory2 = gql`
    mutation getBudgetHistory2(
      $companyId: ID!
      $budgetType: BudgetTypeEnum
      $locale: String
    ) {
      getBudgetHistory2(
        companyId: $companyId
        budgetType: $budgetType
        locale: $locale
      ) {
        result
        filename
        url
      }
    }
  `;

  static getBudgetProjectsForATiers = gql`
    query getBudgetProjects($companyId: ID!, $tiersId: ID) {
      getBudgetProjects(companyId: $companyId, tiersId: $tiersId) {        
        id
        name        
      }
    }
  `;

  // query getBudgetItems($companyId: ID!, $tiersId: ID!) {
  //   getBudgetItems(companyId: $companyId, tiersId: $tiersId) {

  static getBudgetItems = gql`
    query getBudgetItems($companyId: ID!, $tiersId: ID!) {
      getBudgetItems(companyId: $companyId, tiersId: $tiersId) {
        id
        company {
          id
        }
        year
        month
        amount
        dateSaisie
        tiersCollaborator {
          id
          name
        }
        tiers {
          id
          name
        }
        project {
          id
          name
        }
        realValue
        budgetIsReal
      }
    }
  `;

  static getBudgetCategoryItems = gql`
    query getBudgetCategoryItems($companyId: ID!, $categoryId: ID!) {
      getBudgetCategoryItems(companyId: $companyId, categoryId: $categoryId) {
        id
        company {
          id
        }
        year
        month
        amount
        dateSaisie
        tiersCollaborator {
          id
          name
        }
        tiers {
          id
          name
        }
        project {
          id
          name
        }
        realValue
      }
    }
  `;

  static getBudgetItemsByYear = gql`
    query getBudgetItemsByYear(
      $companyId: ID!
      $tiersId: ID!
      $year: Int
      $projectId: ID!
    ) {
      getBudgetItemsByYear(
        companyId: $companyId
        tiersId: $tiersId
        year: $year
        projectId: $projectId
      ) {
        id
        items {
          id
          company {
            id
          }
          year
          month
          amount
          dateSaisie
          tiersCollaborator {
            id
            name
          }
          tiers {
            id
            name
          }
          project {
            id
            name
          }
          realValue
          budgetIsReal
        }
      }
    }
  `;

  static getBudgetCategoryItemsByYear = gql`
    query getBudgetCategoryItemsByYear(
      $companyId: ID!
      $categoryId: ID
      $year: Int
      $projectId: ID
      $tiersClientId: ID
      $tiersId: ID
    ) {
      getBudgetCategoryItemsByYear(
        companyId: $companyId
        categoryId: $categoryId
        year: $year
        projectId: $projectId
        tiersClientId: $tiersClientId
        tiersId: $tiersId
      ) {
        id
        items {
          id
          company {
            id
          }
          year
          month
          amount
          dateSaisie
          tiersCollaborator {
            id
            name
          }
          tiers {
            id
            name
          }
          project {
            id
            name
          }
          realValue
          # isReal
          budgetIsReal
        }
      }
    }
  `;

  static deleteBudgetItems = gql`
    mutation deleteBudgetItems(
      $companyId: ID!
      $tiersId: ID!
      $projectId: ID
      $year: Int
    ) {
      deleteBudgetItems(
        companyId: $companyId
        tiersId: $tiersId
        projectId: $projectId
        year: $year
      ) {
        result
      }
    }
  `;

  static deleteBudgetCategoryItems = gql`
    mutation deleteBudgetCategoryItems(
      $companyId: ID!
      $categoryId: ID
      $projectId: ID
      $tiersClientId: ID
      $tiersId: ID!
      $year: Int
    ) {
      deleteBudgetCategoryItems(
        companyId: $companyId
        categoryId: $categoryId
        projectId: $projectId
        tiersClientId: $tiersClientId
        tiersId: $tiersId
        year: $year
      ) {
        result
      }
    }
  `;

  static getSoldeTiers = gql`
    mutation getSoldeTiers(
      $companyId: ID!
      $tiersType: String
      $dateSolde: DateTime
      $locale: String
    ) {
      getSoldeTiers(
        companyId: $companyId
        tiersType: $tiersType
        dateSolde: $dateSolde
        locale: $locale
      ) {
        result
        filename
        url
      }
    }
  `;

  static isAliasAvailable = gql`
    mutation isAliasAvailable($alias: String!, $companyId: ID!) {
      isAliasAvailable(companyId: $companyId, alias: $alias)
    }
  `;

  static getPeriodSelecterDataForSales = gql`
    query getPeriodSelecterDataForSales($companyId: ID!) {
      getPeriodSelecterDataForSales(companyId: $companyId) {
        id
        type
        budgetBackupName
        budgetBackupDate
        year
      }
    }
  `;

  static getReportSalesData = gql`
    query getReportSalesData(
      $companyId: ID!
      $p1Type: periodSelecterTypeEnum
      $p1Id: ID
      $p1DateDebut: DateTime
      $p1DateFin: DateTime
      $p2Type: periodSelecterTypeEnum
      $p2Id: ID
      $p2DateDebut: DateTime
      $p2DateFin: DateTime
    ) {
      getReportSalesData(
        companyId: $companyId
        p1Type: $p1Type
        p1Id: $p1Id
        p1DateDebut: $p1DateDebut
        p1DateFin: $p1DateFin
        p2Type: $p2Type
        p2Id: $p2Id
        p2DateDebut: $p2DateDebut
        p2DateFin: $p2DateFin
      ) {
        id
        client {
          id
          name
        }
        category {
          id
          ids
          name
          categoryFamily {
            id
            ids
          }
        }
        project {
          id
          name
        }
        vendeur {
          id
          name
        }
        p1Amount
        p1Type
        p2Amount
        p2Type
      }
    }
  `;

  static updateRecurringInvoice = gql`
    mutation updateRecurringInvoice(
      $companyId: ID!
      $id: ID    # recurringInvoiceId > if null, will create a new one.
      $invoiceId: ID
      $active: Boolean
      $dayNumber: Int!
      $monthFrequency: Float!
      $endMonthYear: String
      $generateRealInvoice: Boolean
      $sendInvoice: Boolean
      $lastRecipients: String
    ) {
      updateRecurringInvoice(
        companyId: $companyId
        id: $id
        invoiceId: $invoiceId
        active: $active
        dayNumber: $dayNumber
        monthFrequency: $monthFrequency
        endMonthYear: $endMonthYear
        generateRealInvoice: $generateRealInvoice
        sendInvoice: $sendInvoice
        lastRecipients: $lastRecipients
      ) {
        result
      }
    }
  `;

  static activateRecurrence = gql`
    mutation activateRecurrence(
      $companyId: ID!
      $id: ID     
      $active: Boolean
    ) {
      activateRecurrence(
        companyId: $companyId
        id: $id        
        active: $active
      ) {
        result
      }
    }
  `;

}
